module.exports = {
  common: {
    FindUs: 'Finden sie unsere produkte und dienstleistungen',

    registeredAccount: 'Meldet euch für ein ntl-konto',
    unlock: 'Entsperren sie NTL! Um die macht der anonymität zu erleben',
    invitation: 'Lade einige freunde in den pool ein',
    closeTheDeal: 'Den ersten deal abschließen.',

    sloganthree: 'Willkommen bei NTL!',
    slogantwo: 'Uzxs einzigartiges universum zu entdecken',
    slogantwo2: 'Die mechanismen sind transparent und unangetastet',
    currencySelection: 'Form',
    chart: 'Diagramm',
    details: 'Details',
    entrust: 'vertrauen',
    login: 'Log in',
    register: 'Sign Up',
    loginregister: 'Log in Sign Up',
    indexplaceholde: 'e-mail',
    logout: 'Ausloggen',
    signupnow: 'Register',
    tip: 'Tipps',
    logintip: 'Bitte loggen Sie sich zuerst ein',
    expect: 'Bleib dran!',
    delete: 'Zum Löschen bestätigen?',
    nodata: 'Keine Aufzeichnungen',
    set: 'Die Einstellungen',
    update: 'Ändern',
    slogan: 'Die 50 weltweit führenden digitalen Geldwechsel',
    subslogan: 'Die staatliche Behörde garantiert die Sicherheit der Vermögenswerte',
    more: 'Mehr',
    please: 'Bitte zuerst',
    pleaseselect: 'bitte auswählen',
    searchplaceholder: 'Geben Sie den zu suchenden Währungsnamen ein',
    searchplaceholderswap: 'Geben Sie den zu suchenden Vertragsnamen ein',
    loading: 'Wird geladen...',
    close: 'ausschalten',
    ok: 'IN ORDNUNG',
    fillComplete: 'Bitte geben Sie die vollständigen Informationen ein',
    inputpleaseselect: 'Bitte geben Sie ein',
    showDetail: 'Details anzeigen',
  },
  header: {
    index: 'Zuhause',
    exchange: 'Exchange',
    trade: 'Handeln',
    otc: 'OTC',
    kefu: 'Hilfezentrum',
    asset: 'Finanzzentrum',
    ucenter: 'Account Center',
    service: 'Ankündigung',
    downloadapp: 'Scannen Sie den Code zum Herunterladen und Installieren',
    appdownlaod: 'Download',
    usercenter: 'Persönliches Zentrum',
    helpcenter: 'Hilfezentrum',
    aboutus: 'Über',
    partner: 'Partner',
    bzb: 'BZB',
    assetmanage: 'Geld Management',
    trademanage: 'Transaktionsmanagement',
    activity: 'letzte Veranstaltungen',
    lab: 'NTL Lab',
    ctc: 'Fiat Währung C2C',
    labdetail: 'NTL Lab ● Innovationserfolge teilen',
    invite: 'Promotion Partner',
    whitepaper: 'Weißes Papier',
    scandownload: 'Lade App herunter',
    innovationmanage: 'Innovationsmanagement',
    swap1: 'Swap(U)',
    swap2: 'Swap(COIN)',
    swap3: 'Differenzvertrag',
    swap4: 'Sec Vertrag',
    cexchange: 'QuikExchange',
    option: 'Optionsvertrag',
    second: 'Sekundenvertrag',
    news: 'Nachrichten',
    swapExchange: 'Vertragsgeschäft',
    finance: 'Finanzdienstleistungen',
    fiatCurrency: 'Fiat-Währungstransaktion',
  },
  sectionPage: {
    global_leader: 'Führende globale börse für digitale währung',
    Professional: 'Fachgeschäfte, einfache operationen, digitale transaktionen zu verstehen',
    showMore: 'Mehr sehen',
    brandDesc6:
      'NTL verfügt über Echtzeit-Blockchain-Asset-Zugriffsfunktion, Multi-Currency-Address-Sharing-Technologie, mehrfachen Sicherheitsüberprüfungsschutz und niedrige Transaktions- und Extraktionskosten von Blockchain-Assets in der Branche.',
    brandDesc5:
      'Die technische Lösung von NTL basiert auf Google Cloud und Amazon AWS, die DDOS-Angriffe effektiv verhindert und die Trennung von dynamischen und statischen Daten unterstützt; Es unterstützt Hot Data Caching, Remote Disaster Recovery und parallele Erweiterung. Die weltweit führende technische Architektur gewährleistet sichere Transaktionen der Benutzer.',
    brandDesc4:
      'NTL verfügt derzeit über One-Stop-Krypto-Asset-Services wie Währung, unbefristete Verträge, Spot, Option, Finanzkredite und unterstützt mehrere Sprachversionen wie Chinesisch/Englisch/Japanisch/Koreanisch/.',
    brandDesc3:
      'NTL ist bestrebt, eine sichere, stabile, bequeme, faire und seriöse internationale Blockchain-Asset-Börse zu sein, die das Vertrauen der Benutzer verdient und die Sicherheit der Handelsinformationen und Vermögenswerte der Benutzer umfassend gewährleistet.',
    brandTitle2: 'One-Stop-Verschlüsselungs-Asset-Dienst',
    ptaqTitle: 'Plattformsicherheit',
    ptaqContent:
      'Mit Hash-Algorithmus-Verschlüsselung die weltweit führende Sicherheitszertifizierung',
    ptslTitle: 'Plattformstärke',
    ptslContent: 'Die weltweit größte Bitcoin-Handelsplattform',
    newsTitle: 'Multi-Terminal-APP',
    brandTitle: 'Über NTL',
    brandDetail: 'Ehrlichkeit | Fairness | Begeisterung | Offenheit',
    brandDesc1:
      'ntlex.com wurde von einer Gruppe früher Bitcoin-Teilnehmer und -Freaks gegründet. Die Kernmitglieder des Teams stammen von bekannten Unternehmen wie Google, Microsoft, Alibaba, Tencent usw. mit umfassender Forschungs- und Entwicklungsstärke und umfassender Erfahrung im Betrieb von Internetprodukten.',
    brandDesc2:
      "ntlex.com ist als grundlegender Blockchain-Dienstleister positioniert, der es sich zur Aufgabe gemacht hat, Benutzern auf der ganzen Welt hochwertige verschlüsselte Handelsplattformen für Vermögenswerte bereitzustellen, das Grundprinzip 'nichts Böses tun' einzuhalten und darauf zu bestehen, Kunden ehrlich, fair und enthusiastisch zu bedienen. Eine offene Haltung begrüßt alle Partner / Projekte, die den grundlegenden Interessen der Nutzer zugute kommen. ",
    gettingstart: 'Erste Schritte für Neulinge | Schnell Münzen kaufen',
    officialstart: 'NTL offizieller Einsteigerhilfekanal',
    oneminutebuy: 'Währungstransaktion',
    oneminutebuytips:
      'Verwenden Sie ein digitales Asset, um es direkt gegen ein anderes auszutauschen',
    baseknow: 'Verträge auf dauer.',
    baseknowtips: 'T + 0 wechselseitiger Handel mit virtuellen Gütern als Tauschvertrag',
    baseexchange: 'Optionsvertrag',
    baseexchangetips: 'Ist ein digitales Asset-Derivat',
    usersocial: 'Schneller Austausch',
    usersocialtips: 'Tauschen Sie schnell digitale Assets aus',
    mainboard: 'Main Board Trading Area',
    preview: 'Vorherige Seite',
    nextpage: 'Nächste Seite',
    downloadwhite:
      'Laden Sie das Whitepaper herunter (oder klicken Sie mit der rechten Maustaste auf das Whitepaper -> "Speichern unter ...")',
    brandTitle1: 'Internationale Börse für Derivate digitaler Vermögenswerte',
  },
  nav: {
    shouye: 'Zuhause',
    jiaoyi: 'Fiat-Währungstransaktion',
    dingdan: 'Auftragsverwaltung',
    zijin: 'Finanzzentrum',
    yonghu: 'User Center',
    bibi: 'Exchange',
    fabu: 'Eine Anzeige aufgeben',
    ptjy: 'Plattformtransaktionen',
    ptaq: 'Plattformsicherheit',
    ptsl: 'Plattformstärke',
    xwzx: 'Multi-Terminal-APP',
  },
  progress: {
    already: 'Mined',
    total: 'Insgesamt können 6 Milliarden BHB abgebaut werden',
  },
  service: {
    USDT: 'USDT',
    BTC: 'BTC',
    ETH: 'ETH',
    CUSTOM: '自选',
    COIN: 'Währung',
    favor: 'Sammlung',
    symbol: 'Handelspaar',
    NewPrice: 'Letzter Preis',
    ExchangeNum: 'Anzahl der Transaktionen',
    FeePercent: 'Finanzierungsrate',
    Change: 'Amplitude',
    OpenPrice: 'Eröffnungskurs',
    PriceTrend: 'Preisentwicklung',
    Operate: 'Betrieb',
    Exchange: 'Geh zum Deal',
    trading: 'Handel jetzt',
    high: '24h höchster Preis',
    low: '24h niedrigster Preis',
  },
  exchange: {
    loginBuy: 'Buy After Login (BTC)',
    loginOut: 'Verkaufen nach Anmeldung (BTC)',
    coin: 'Währung',
    symbol: 'Handelspaar',
    lastprice: 'Letzter Preis',
    daychange: 'Amplitude',
    market: 'Markt',
    favorite: 'Sammlung',
    do_favorite: 'gesammelt',
    cancel_favorite: 'Unfavorit',
    type: 'Arten von',
    dealamount: 'Umsatz',
    high: '高',
    low: 'Niedrig',
    vol: '24H 量',
    buy: 'Kaufen',
    sell: 'Ausverkaufen',
    limited_price: 'Limit Price',
    market_price: 'Marktpreis',
    fees_rate: 'Ladestrom',
    balance: 'Vermögenswerte',
    or: 'Oder',
    starttrade: 'Mit dem handel beginnen',
    canuse: 'Verfügbar',
    recharge: 'Münze aufladen',
    buyprice: 'Kaufpreis',
    buynum: 'Kaufbetrag',
    amount: 'Transaktionshöhe',
    buyin: 'Kaufen',
    disablebuyin: 'Marktpreiskauf ist verboten',
    buytip: 'Kaufen Sie zum besten Preis auf dem Markt',
    sellprice: 'Verkaufspreis',
    sellnum: 'Verkaufsvolumen',
    sellout: 'Ausverkaufen',
    disablesellout: 'Verkauf zum Marktpreis ist verboten',
    selltip: 'Zum besten Preis auf dem Markt verkaufen',
    curdelegation: 'Aktueller Delegierter',
    hisdelegation: 'Delegationsverlauf',
    realtransaction: 'Echtzeit-Transaktion',
    num: 'Menge',
    price: 'Preis',
    direction: 'Richtung',
    time: 'Zeit',
    stall: 'Gangstellung',
    total: 'Gesamtsumme',
    traded: 'Geschäft abgeschlossen',
    action: 'Betrieb',
    undo: 'Bestellung stornieren',
    delegationnum: 'Vertrauenswürdiger Betrag',
    done: 'Geschäft abgeschlossen',
    status: 'Status',
    finished: 'abgeschlossen',
    canceled: 'Abgesagt',
    parted: 'Teiltransaktion',
    tip: 'Prompt',
    buyamounttip: 'Bitte geben Sie den Kaufbetrag ein',
    buyamounttipwarning: 'Kaufmenge darf nicht höher sein als',
    success: 'Erfolgreich eingereicht',
    pricetip: 'Bitte geben Sie den Transaktionsbetrag ein',
    pricetipwarning: 'Der Transaktionsbetrag darf nicht höher sein als',
    sellamounttip: 'Bitte geben Sie den verkauften Betrag ein',
    sellamounttipwarning: 'Die verkaufte Menge darf nicht höher sein als',
    sellpricetip: 'Bitte geben Sie den Verkaufspreis ein',
    sellpricetipwarning: 'Der Verkaufspreis kann nicht höher sein als',
    undotip: 'Sind Sie sicher, die Bestellung zu stornieren? ',
    cancelsuccess: 'Bestellung erfolgreich storniert!',
    marketprice: 'Marktpreis',
    expand: {
      time: 'Zeit',
      price: 'Preis',
      amount: 'Menge',
      fee: 'Bearbeitungsgebühr',
    },
    realtime: 'Zeitteilung',
    kline: 'K-Liniendiagramm',
    depth: 'Tiefenkarte',
    publishstate0: 'Die Veranstaltung beginnt gleich, bitte warten ...',
    publishstate1:
      'Die Veranstaltung ist kurz vor dem Ende, bitte handeln Sie so schnell wie möglich ...',
    publishstate2: 'Der aktive Auftrag wird derzeit konsolidiert, bitte warten ...',
    publishstate3: 'Konsolidierung ist vorbei, bitte frei handeln ...',
    publishdetail: 'Details zu Aktivitätsregeln',
    publishprice: 'Ausgabepreis',
    publishamount: 'Gesamt',
    publishcounttxt0: 'Es ist noch übrig, bevor die Veranstaltung beginnt',
    publishcounttxt1: 'Es ist noch übrig, bevor die Veranstaltung endet',
    publishcounttxt2: 'Es ist noch bis zum Ende der Liquidation',
    publishcounttxt3: 'Die Veranstaltung ist vorbei',
    dateTimeDay: 'Himmel',
    dateTimeHour: 'Zeit',
    dateTimeMinutes: 'Minute',
    dateTimeSeconds: 'zweite',
    moredetail: 'Mehr Details',
  },
  swap: {
    contract: 'Vertrag',
    swapindex: 'Nachhaltig',
    coin: 'Währung',
    symbol: 'Handelspaar',
    volume: 'Lautstärke',
    lastprice: 'Letzter Preis',
    daychange: '24H hoch oder runter',
    market: 'Markt',
    favorite: 'Sammlung',
    do_favorite: 'gesammelt',
    cancel_favorite: 'Unfavorit',
    type: 'Arten von',
    dealamount: 'Umsatz',
    high: 'hoch',
    low: 'Niedrig',
    vol: '24H Volumen',
    buy: 'Kaufen',
    sell: 'Ausverkaufen',
    limited_price: 'Limit Price Order',
    market_price: 'Marktpreisprovision',
    spot_price: 'Stop Profit Stop Loss',
    fees_rate: 'Ladestrom',
    balance: 'Vermögenswerte',
    or: 'Oder',
    starttrade: 'Mit dem handel beginnen',
    canuse: 'Verfügbar',
    recharge: 'Münze aufladen',
    buyprice: 'Kaufpreis',
    buynum: 'Kaufbetrag',
    amount: 'Transaktionshöhe',
    buyin: 'Kaufen',
    disablebuyin: 'Marktpreiskauf ist verboten',
    buytip: 'Kaufen Sie zum besten Preis auf dem Markt',
    sellprice: 'Verkaufspreis',
    sellnum: 'Verkaufsvolumen',
    sellout: 'Ausverkaufen',
    disablesellout: 'Verkauf zum Marktpreis ist verboten',
    selltip: 'Zum besten Preis auf dem Markt verkaufen',
    curdelegation: 'Aktueller Delegierter',
    hisdelegation: 'Geschichtskommission',
    realtransaction: 'Echtzeit-Transaktion',
    num: 'Menge',
    price: 'Preis',
    direction: 'Richtung',
    time: 'Zeit',
    stall: 'Gangstellung',
    total: 'Gesamtsumme',
    traded: 'Geschäft abgeschlossen',
    action: 'Betrieb',
    undo: 'Bestellung stornieren',
    delegationnum: 'Vertrauenswürdiger Betrag',
    done: 'Geschäft abgeschlossen',
    status: 'Status',
    finished: 'abgeschlossen',
    canceled: 'Abgesagt',
    parted: 'Teiltransaktion',
    tip: 'Prompt',
    buyamounttip: 'Bitte geben Sie den Kaufbetrag ein',
    buyamounttipwarning: 'Kaufmenge darf nicht höher sein als',
    success: 'Erfolgreich eingereicht',
    pricetip: 'Bitte geben Sie den Transaktionsbetrag ein',
    pricetipwarning: 'Der Transaktionsbetrag darf nicht höher sein als',
    sellamounttip: 'Bitte geben Sie den verkauften Betrag ein',
    sellamounttipwarning: 'Die verkaufte Menge darf nicht höher sein als',
    sellpricetip: 'Bitte geben Sie den Verkaufspreis ein',
    sellpricetipwarning: 'Der Verkaufspreis kann nicht höher sein als',
    undotip: 'Sind Sie sicher, die Bestellung zu stornieren? ',
    cancelsuccess: 'Bestellung erfolgreich storniert!',
    marketprice: 'Marktpreis',
    expand: {
      time: 'Zeit',
      price: 'Preis',
      amount: 'Menge',
      fee: 'Bearbeitungsgebühr',
    },
    realtime: 'Zeitteilung',
    kline: 'K-Liniendiagramm',
    depth: 'Tiefenkarte',
    open: 'Freie Stelle',
    close: 'Position schließen',
    latestdeal: 'Letzte Transaktion',
    myswapaccount: 'Mein Vertragskonto',
    accountmode: 'Kontomodus',
    accountmargin: 'Vertrag Mehrfach',
    accountquanyi: 'Account Total Equity',
    profitandloss: 'Nicht realisierter Gewinn und Verlust',
    principalAmount: 'Verfügbare Spanne',
    positionAmount: 'Positionsrand',
    frozenAmount: 'Freeze Margin',
    principalRate: 'Fondsnutzungsrate',
    zijinhuazhuan: 'Geldüberweisung',
    up: ' viele',
    down: 'Leer',
    canup: 'Kann mehr öffnen',
    candown: 'Kann leer öffnen',
    cancloseup: 'Short Position kann geschlossen werden',
    canclosedown: 'Mehrere Positionen können geschlossen werden',
    openup: 'Kaufen Sie lange offen',
    opendown: 'Verkaufen, um kurz zu öffnen',
    closeup: 'Short Short kaufen',
    closedown: 'Mehr verkaufen',
    currentposition: 'Aktuelle Position',
    assetsdetail: 'Fondsdetails',
    marginMode1: 'Fahrgestell nach Lager',
    marginMode2: 'Volles Lager',
    modifyMarginModeTitle: 'Kontomodus ändern',
    modifyLeverage: 'Vertragsmultiplikator anpassen',
    moredetail: 'Mehr Details',
    shareNumber: 'Zhang',
    entrustprice: 'Sendungspreis',
    triggleprice: 'Auslöserpreis',
    openvolume: 'Anzahl der offenen Stellen',
    closevolume: 'Menge zum Schließen',
    triggleplaceholder: 'Der Standardprovisionspreis ist der Marktpreis',
    marketpriceplaceholder: 'Verkaufen zum besten Marktpreis',
    levmaxtip: 'Das Vertragsmultiplikator darf nicht höher sein als das höchste Vielfache',
    levmintip: 'Das Vertragsmultiplikator darf nicht niedriger als das Mindestmultiplikator sein',
    marginModeSuccessTip: 'Vertragskontomodell erfolgreich geändert',
    noenoughbalance: 'Unzureichende Kontomarge',
    pleaseinputopenvolume: 'Die offene Positionsmenge muss größer als 0 sein',
    pleaseinputcorrectopenvolume: 'Bitte geben Sie die richtige Öffnungsmenge ein',
    pleaseinputrightentrustprice: 'Bitte geben Sie den richtigen Bestellpreis ein',
    noenoughposition: 'Unzureichende liquidierbare Positionen',
    pleaseinputclosevolume: 'Die Schlussmenge muss größer als 0 sein',
    pleaseinputcorrectclosevolume: 'Bitte geben Sie die richtige Schlussmenge ein',
    pos_Pl: 'Gewinn',
    pos_Ratio: 'Rendite',
    pos_pos: 'Offenes Interesse',
    pos_canClose: 'Amountable, um flach zu sein',
    pos_openPrice: 'Durchschnittlicher Eröffnungspreis',
    pos_leverage: 'Vertrag Mehrfach',
    pos_margin: 'Aktuelle Marge',
    pos_mRatio: 'Margin Rate',
    pos_cmRatio: 'Maintenance Margin Rate',
    pos_long: 'Multiple',
    pos_short: 'Kurz',
    ent_entrustType: 'Position öffnen / schließen',
    ent_direction: 'Richtung',
    ent_type: 'Delegationstyp',
    ent_trigglePrice: 'Auslöserpreis',
    ent_entrustPrice: 'Sendungspreis',
    ent_tradedPrice: 'Endgültiger Preis',
    ent_margin: 'Spanne',
    ent_volume: 'Bestellmenge',
    ent_status: 'Delegationsstatus',
    ent_status1: 'Anvertraut',
    ent_status2: 'Widerrufen',
    ent_status3: 'Delegierung fehlgeschlagen',
    ent_status4: 'Delegation erfolgreich',
    ent_statusblast: 'Ausbrechen',
    ent_pl: 'Abrechnungsgewinn und -verlust',
    ent_fee: 'Bearbeitungsgebühr',
    triggerpriceshouldbigger: 'Der Auslöserpreis muss größer als 0 sein',
  },
  second: {
    balance: 'Balance',
    profitability: 'Rentabilität',
    opentime: 'Offene Zeit',
    transactionMode: 'Transaktionsmodus',
    currentPosition: 'Aktuelle Position',
  },
  ctc: {
    title: 'One-Click-Handel ● Plattform-Hosting ● Sicher und sicher',
    desc: 'Die digitalen Assets werden von der Biyan-Plattform verwaltet, um die Sicherheit der Benutzer-Assets zu gewährleisten',
    buyin: 'Kaufen',
    sell: 'Verkaufen',
    buyprice: 'Kaufpreis',
    sellprice: 'Verkaufspreis',
    buynum: 'Kaufbetrag',
    sellnum: 'Verkaufte Menge',
    payamount: 'Abrechnungssumme',
    getamount: 'Abrechnungssumme',
    avabalance: 'Verfügbare Anzahl',
    time: 'Transaktionsstunde',
    tip: 'Eingabeaufforderung',
    notice: 'Tipps',
    notice1:
      '1. Der Fiat-Währungshandelsbereich ist für Asset-Transaktionen zwischen Benutzern und Akzeptoren vorgesehen. Gelder werden nicht auf die Plattform übertragen, und die Plattform akzeptiert keine Aufladung / Überweisung von RMB.',
    notice2:
      '2. Die Fiat-Währungshandelsakzeptoren haben die Echtnamenauthentifizierung bestanden, vorausgesetzt, die Transaktionsmarge und die Token werden von der Plattform gehostet. Sie können sie mit Vertrauen austauschen.',
    notice3:
      '3. Die Servicezeit des Akzeptors beträgt täglich 09: 00-21: 00 Uhr. Die Annahme wird innerhalb von 30 Minuten nach Eingang der Bestellung abgeschlossen, und die Transaktion, die nicht innerhalb von 2 Stunden abgeschlossen wurde, ist ungültig.',
    notice4:
      '4. Der legale Währungshandelsbereich unterstützt Bankkarten, und Sie müssen Ihr mit echtem Namen verifiziertes Konto für die Überweisung verwenden.',
    notice5:
      '5. Um die Sicherheit von Transaktionsgeldern zu gewährleisten, müssen Benutzer bei Fiat-Währungstransaktionen die Authentifizierung mit echtem Namen bestehen. Bitte legen Sie das Passwort für den Fonds fest und erhalten Sie das Konto rechtzeitig nach dem Passieren der Authentifizierung mit echtem Namen. Andernfalls ist die Transaktion nicht möglich.',
    payType: 'Bezahlverfahren',
    receiveType: 'Bezahlverfahren',
    moneyTips:
      'Der oben genannte Betrag dient nur als Referenz, bitte beziehen Sie sich auf den tatsächlichen Abrechnungsbetrag nach der folgenden Bestellung',
    verifyset: 'Echtheitsauthentifizierung / Fondspasswort',
    payset: 'Zahlungs- / Belegeinstellungen',
    trade: 'Transaktion',
    input50tips: 'Bitte geben Sie eine Zahl zwischen 50 ~ 50000 ein',
    bank: 'Bankkarte',
    alipay: 'Alipay',
    wechatpay: 'WeChat',
    payaccountset: 'Zahlungskontoeinstellungen',
    useselfaccount:
      'Bitte stellen Sie sicher, dass Sie ein Inkasso- / Zahlungskonto verwenden, das Ihrer tatsächlichen Namensüberprüfung entspricht',
    orderSn: 'Bestellnummer',
    tradetime: 'Bestellzeitpunkt',
    direction: 'Art der Transaktion',
    amount: 'Menge (USDT)',
    money: 'Gesamt (CNY)',
    price: 'Stückpreis (CNY)',
    status: 'Status',
    operate: 'Betrieb',
    moredetail: 'Weitere Handelsanweisungen',
  },
  cexchange: {
    use: 'Verwenkonsumierendung',
    consume: 'Austausch',
    title: 'Quick Exchange',
    desc: 'Austausch per Mausklick, Nutzen Sie die Vorteile',
    quantity: 'Austauschmenge',
    inputtips1: 'Geben Sie eine benutzerdefinierte Menge ein',
    choosecurrency: 'Wechselwährung wählen',
    all: 'Alle',
    maxtip: 'Maximale Einlösung ',
    mintip: 'Mindestumtausch ',
    totalpay: 'Gesamtumtauschbetrag',
    restricted: 'Heutige Limited Edition',
    currentprice: 'Aktueller Wechselkurs',
    nextprice: 'Nächster Wechselkurs',
    confirmpay: 'Exchange bestätigen',
    assets: 'Saldo:',
    loginFirst: 'Bitte loggen Sie sich zuerst ein',
    success: 'Herzlichen Glückwunsch! Erfolgreiche Erlösung!',
    tip: 'Eingabeaufforderung',
    confirmmsg: 'Bestätigen',
  },
  option: {
    title: 'Optionsvertrag',
    buyupreward: 'Gesamtkaufsteigerung',
    buydownreward: 'Total Buy and Loss',
    quantity: 'Open Position Amount',
    myamount: 'Meine offene Position',
    buyup: 'Bullish',
    buydown: 'Bärisch',
    history: 'Vergangene Ergebnisse',
    seriers: 'Zuerst',
    period: 'Zeitraum',
    currentoption: 'Aktueller Prognosezeitraum',
    openprice: 'Eröffnungspreis',
    currentprice: 'Derzeitiger Preis',
    openprice1: 'Eröffnungspreis',
    closeprice: 'Schlusskurs',
    opentime: 'Öffnungszeit',
    closetime: 'Schließzeit',
    progress: 'Fortschritt prognostizieren',
    loginFirst: 'Bitte loggen Sie sich zuerst ein!',
    selectAmount: 'Bitte wählen Sie die Anzahl der Wetten',
    balancenotenough: 'Das verfügbare Guthaben ist unzureichend!',
    betsuccess: 'Herzlichen Glückwunsch! Die Wette ist erfolgreich!',
    noopening: 'Kein Optionsvertrag ausstehend',
    col_createTime: 'Erstellte Zeit',
    col_direction: 'Prognoserichtung',
    col_result: 'Prognoseergebnis',
    col_optionNo: 'Anzahl der Vertragslaufzeiten',
    col_betAmount: 'Open Position Amount',
    col_rewardAmount: 'Bonusmenge',
    col_fee: 'Open Position Fee',
    col_winfee: 'Pumpen',
    win: 'Erfolg',
    lose: 'Gescheitert',
    wait: 'wird bearbeitet',
    avaliablebalance: 'Verfügbares Guthaben',
    login: 'Bitte loggen Sie sich zuerst ein',
    kline: 'Echtzeit-Zitate',
  },
  otc: {
    payment_detail: 'Details zur Zahlungsmethode',
    bind_payment: 'Zahlungsmethode binden',
    payment_placeholder: 'Bitte wählen Sie eine Zahlungsmethode aus',
    payment: 'Zahlungsmethode',
    ad: 'Werbezentrum',
    buyin: 'Kaufen',
    sellout: 'Ausverkaufen',
    merchant: 'Geschäft',
    applymerchant: 'Als zertifizierter Händler bewerben',
    volume: 'Anzahl der Transaktionen',
    paymethod: 'Bezahlverfahren',
    amount: 'Menge',
    price_coin: 'Preis / Münze',
    operate: 'Betrieb',
    validate: 'Bitte führen Sie zuerst eine Authentifizierung mit echtem Namen durch',
    sell: 'Ausverkaufen',
    buy: 'Kaufen',
    transaction: 'Verkaufstransaktion',
    buttontxt: 'Händler werden',
    title: 'Fiat-Währungstransaktion',
    desc: 'Bequemer, sicherer und schneller Handel mit digitalen Währungen',
    title1: 'Dynamische Anpassung',
    desc1: 'Nach Marktpreisschwankungen in Echtzeit',
    title2: 'Kostenlose Bearbeitungsgebühr',
    desc2:
      'Benutzer sehen, was sie bekommen, außer dem Kauf- und Verkaufspreis sind keine Plattformgebühren erforderlich',
    title3: 'Sofortige Transaktion',
    desc3:
      'Einführung der Plattform für Händler, intelligentes Matching, Bestellungstransaktionen, kein Warten auf Matching',
    title4: 'Plattformgarantie',
    desc4:
      'Plattform-zertifizierte Händler, sicher, 24-Stunden-Kundendienst begleitet Transaktionen',
    myad: {
      title: 'Meine Anzeigen',
      post: 'Eine Anzeige aufgeben',
      alert:
        '[Erinnerung]: Wenn der Mindesttransaktionsbetrag der Anzeige zuzüglich der Bearbeitungsgebühr höher ist als der verbleibende Betrag der Anzeige, wird die Anzeige automatisch aus den Regalen entfernt.',
      no: 'Anzeigenummer',
      type: 'Werbetyp',
      sell: 'Online-Verkauf',
      buy: 'Online kaufen',
      limit: 'Bestelllimit',
      remain: 'Der verbleibende Betrag',
      coin: 'Währung',
      created: 'Erstellungszeitpunkt',
      operate: 'Betrieb',
      errmsg: 'Werbung kann erst bearbeitet werden, nachdem sie entfernt wurde',
      update: 'Ändern',
      shelf: 'Verkauf',
      dropoff: 'Ausverkauf',
      delete: 'Löschen',
    },
    myorder: 'Meine Bestellung',
    chatline: {
      status_1: 'Der Käufer hat nicht bezahlt und wartet darauf, dass der Käufer zahlt! ',
      status_2: 'Der Käufer hat bezahlt und wartet auf die Freigabe durch den Verkäufer! ',
      status_3: 'Die Bestellung wurde abgeschlossen! ',
      status_4: 'Gegen den Befehl wird Berufung eingelegt! ',
      status_5: 'Bestellung wurde storniert! ',
      loadmore: 'Mehr laden',
      warning:
        'Tipps zur Betrugsprävention: In letzter Zeit haben Betrüger wiederholt Überweisungsinformationen und gefälschte Überweisungsdaten verwendet, um Betrug zu begehen. Bitte melden Sie sich bei Ihrem Empfangskonto an, um dies zu überprüfen. Sorgen Sie für die Sicherheit der überwiesenen Beträge und vermeiden Sie das Risiko, dass Bankkarten eingefroren werden! ',
      contenttip:
        'Bitte geben Sie den Chat-Inhalt ein und drücken Sie die Eingabetaste, um zu senden',
      contentmsg: 'Nachricht darf nicht leer sein',
    },
    chat: {
      seller: 'Verkäufer',
      buyer: 'Käufer',
      exchangeamount: 'Der Transaktionsbetrag',
      operatetip: 'Operationstipps',
      operatetip_1:
        'Bitte schließen Sie die Zahlung gemäß dem von der anderen Partei angegebenen Konto innerhalb der angegebenen Frist ab und klicken Sie auf diese Seite',
      finishpayment: 'Zahlung abgeschlossen',
      operatetip_1_1:
        'Bitte beachten Sie die Transaktionsnummer in der Nachricht, wenn Sie Geld überweisen',
      operatetip_1_2:
        'Nach Erhalt der Zahlung bestätigt der Verkäufer die Zahlung auf der Website und das System gibt die von Ihnen gekauften digitalen Assets automatisch auf Ihr Konto aus. Bitte achten Sie auf Scheck und Empfang',
      note: 'Hinweis',
      notetip:
        'Bitte verwenden Sie keine andere Chat-Software, um mit der anderen Partei zu kommunizieren, geschweige denn, um Dateien, E-Mail-Anhänge usw. zu akzeptieren, die Ihnen von der anderen Partei gesendet wurden. Alle Kommunikationslinks sollten im Chat-Fenster auf dieser Seite ausgefüllt werden.',
      operatetip_2_1:
        'Die von Ihnen verkauften digitalen Assets wurden zur Aufbewahrung und zum Einfrieren an die Plattform übergeben. Bitte klicken Sie auf , nachdem Sie den Zahlungseingang der anderen Partei bestätigt haben',
      operatetip_2_2:
        'Bitte glauben Sie keinem Grund, die Freigabe von Münzen zu fordern und die digitalen Vermögenswerte freizugeben, nachdem Sie den Erhalt des Geldes bestätigt haben, um Verluste zu vermeiden! ',
      operatetip_2_3:
        'Melden Sie sich nach Erhalt der SMS beim Online-Banking oder Mobile-Banking an, um zu bestätigen, ob das Geld dem Konto gutgeschrieben wurde, um die falsche Freigabe digitaler Assets aufgrund des Empfangs betrügerischer SMS zu vermeiden! ',
      confirmrelease: 'Freigabe bestätigen',
      paydigital: 'Bezahlen Sie für digitale Assets',
      orderstatus: 'Bestellstatus',
      orderstatus_1: 'Zahlung abgeschlossen',
      orderstatus_2: 'Order Appeal',
      orderstatus_3: 'Freigabe bestätigen',
      orderstatus_4: 'Deal stornieren',
      orderstatus_5: 'Order Appeal',
      order: 'Auftrag',
      and: 'gegen',
      transition: 'Die Transaktion',
      transprice: 'Handelspreis',
      transnum: 'Anzahl der Transaktionen',
      transmoney: 'Der Transaktionsbetrag',
      tip1: 'Der Benutzer hat die Bankkartennummer nicht vorübergehend hinzugefügt',
      tip2: 'Benutzer hat vorübergehend kein Alipay-Konto hinzugefügt',
      tip3: 'Benutzer hat vorübergehend kein WeChat-Konto hinzugefügt',
      zfb: 'Alipay',
      wx: 'WeChat',
      qrcode: 'QR-Code',
      msg1: 'Sind Sie sicher, dass die Zahlung abgeschlossen wurde',
      msg2: 'Zahlung wird nicht erstattet! Sind Sie sicher, die Bestellung zu stornieren? ',
      msg3: '[Wichtig]: Zahlungen werden nicht erstattet! Sind Sie sicher, die Bestellung zu stornieren? ',
      msg4: 'Bezahlte, nicht erhaltene Münzen',
      msg5: 'Münze wurde bezahlt, Zahlung wurde nicht erhalten',
      tip: 'Prompt',
      comptype: 'Art der Beschwerde',
      compremark: 'Beschwerde Bemerkungen',
      willcomp: 'Ich möchte mich beschweren',
      msg6: 'Sind Sie sicher, Münzen freizugeben? ',
      result_1: 'Warten auf Zahlung',
      result_2: 'Warten auf Veröffentlichung',
      result_3: 'abgeschlossen',
      result_4: 'Reizvoll',
      result_5: 'Abgesagt',
      msg7: 'Fondspasswort',
      msg7tip: 'Bitte geben Sie das Passwort des Fonds ein',
    },
    checkuser: {
      emaildone: 'Mail wurde authentifiziert',
      emailundo: 'Mail ist nicht authentifiziert',
      teldone: 'Handynummer wurde verifiziert',
      telundo: 'Handynummer wird nicht verifiziert',
      idcarddone: 'ID-Karte wurde verifiziert',
      idcardundo: 'ID ist nicht authentifiziert',
      language: 'Sprache',
      languagetext: 'Chinesisch',
      languagetext1: 'English',
      registtime: 'Registrierungszeit',
      exchangetimes: 'Kumulierte Anzahl von Transaktionen',
      exchangeinfo: 'Die Transaktionsinformationen',
      tablabel1: 'Online-Verkauf',
      tablabel2: 'Online kaufen',
      col_symbol: 'Währung',
      col_paymode: 'Bezahlverfahren',
      col_num: 'Menge',
      col_price: 'Preis',
      col_created: 'Veröffentlichkeitsdatum',
      col_operate: 'Betrieb',
      operatemsg: 'Bitte führen Sie zuerst eine Authentifizierung mit echtem Namen durch',
      buyin: 'Kaufen',
      sellout: 'Ausverkaufen',
    },
    tradecenter: {
      postad: 'Eine Anzeige aufgeben',
      exchange: 'GCC-Transaktion',
      buyin: 'Ich möchte kaufen',
      sellout: 'Ich möchte verkaufen',
    },
    tradeinfo: {
      emaildone: 'Mail wurde authentifiziert',
      emailundo: 'Mail ist nicht authentifiziert',
      teldone: 'Handynummer wurde verifiziert',
      telundo: 'Handynummer wird nicht verifiziert',
      idcarddone: 'ID-Karte wurde verifiziert',
      idcardundo: 'ID ist nicht authentifiziert',
      exchangetimes: 'Transaktionen',
      price: 'Preis',
      num: 'Menge',
      paymethod: 'Bezahlverfahren',
      exchangelimitamount: 'Transaktionslimit',
      location: 'Ort',
      location_text: 'China',
      exchangeperiod: 'Handelszeitraum',
      minute: 'Minute',
      amounttip: 'Bitte geben Sie den Betrag ein',
      numtip: 'Bitte geben Sie die Menge ein',
      remarktip: 'Sag ihm deine Bitte',
      remarktitle: 'Bemerkungen Informationen',
      exchangetitle: 'Handelsnotizen',
      exchange_tip1:
        'Nachdem Sie eine Transaktionsanforderung initiiert haben, wird die digitale Währung in der Verwahrung gesperrt und von der Plattform geschützt. Wenn Sie Verkäufer sind, können Sie nach dem Einleiten einer Transaktionsanforderung aufladen und auf die Zahlung durch den Käufer warten. Der Käufer zahlt innerhalb der Zahlungsfrist. Sie sollten die digitale Währung nach Erhalt der Zahlung freigeben. ',
      exchange_tip2:
        'Lesen Sie vor dem Handel die "Platform Network Service Terms" und Hilfedokumente wie FAQs und Handelshandbücher. ',
      exchange_tip3:
        'Vorsicht vor Lügnern! Bitte überprüfen Sie die Bewertung, die der Benutzer vor dem Handel erhalten hat, und achten Sie mehr auf das neu erstellte Konto. ',
      exchange_tip4:
        'Bitte beachten Sie, dass Rundungen und Preisschwankungen den endgültigen Transaktionsbetrag der digitalen Währung beeinflussen können. Der von Ihnen eingegebene feste Betrag bestimmt den endgültigen Betrag, und der Betrag der digitalen Währung wird zum Zeitpunkt der Anforderung aus dem Echtzeit-Wechselkurs berechnet. ',
      exchange_tip5:
        'Der Sorgerechtsdienst schützt sowohl Käufer als auch Verkäufer von Online-Transaktionen. Im Streitfall werden wir alle bereitgestellten Informationen auswerten und die verwahrte digitale Währung an ihren rechtmäßigen Eigentümer weitergeben. ',
      warning1: 'Geben Sie bis zu 2 Dezimalstellen ein',
      warning2: 'Der Bestellbetrag ist',
      warning3: 'Geben Sie bis zu 8 Dezimalstellen ein',
      warning4: 'Bestellmenge ist',
      confirmbuyin: 'Zum Kauf bestätigen',
      confirmsellout: 'Zum Verkauf bestätigen',
      buyin: 'Kaufen',
      sellout: 'Ausverkaufen',
      warning5: 'Bitte geben Sie die Bestellung nach Bedarf ein',
    },
    publishad: {
      createad: 'Werbetransaktion erstellen',
      msg1: 'Wenn Sie häufig handeln, können Sie Ihre eigenen Handelsanzeigen erstellen. Wenn Sie nur gelegentlich handeln, empfehlen wir Ihnen, direkt zu suchen ',
      msg2: 'Eine Transaktionsanzeige erstellen ist',
      msg3: 'Kostenlos',
      msg4: 'Wenn Sie die erstellte Anzeige direkt bearbeiten möchten, sehen Sie sich bitte an',
      tradead: 'Transaktionswerbung',
      myad: 'Meine Anzeigen',
      iwant: 'Ich möchte',
      sellonline: 'Online-Verkauf',
      buyonline: 'Online kaufen',
      exchangecoin: 'Handelswährung',
      country: 'Land',
      currency: 'Währung',
      openfixedprice: 'Offener Festpreis',
      open: 'Öffnen',
      close: 'ausschalten',
      usetip:
        'Nach der Aktivierung schwankt Ihr Währungspreis nicht mit dem Markt und der Preis bleibt unverändert. ',
      premiseprice: 'Prämie',
      premisepricetip: 'Bitte setzen Sie Ihre Prämie',
      fixedprice: 'Festpreis',
      fixedpricetip: 'Bitte geben Sie Ihren Transaktionspreis ein',
      marketprice: 'Marktreferenzpreis',
      marketpricetip:
        'Prämie bezieht sich auf den Prozentsatz, der höher ist als der aktuelle Marktpreis',
      exchangeprice: 'Handelspreis',
      formual: 'Preisformel',
      num: 'Menge',
      num_text1: 'Bitte geben Sie ein, was Sie wollen',
      num_text2: 'Menge',
      exchangeperiod: 'Handelszeitraum',
      exchangeperiod_text1: 'Bitte geben Sie Ihren Transaktionszeitraum ein',
      minute: 'Minute',
      tip1: 'Wie viel Zeit der Käufer für den Handel benötigt, geben Sie bitte eine ganze Zahl ein',
      tip2: '[Erinnerung] Gehen Sie zum Personal Center, um die Zahlungsmethode zu binden / hinzuzufügen',
      tip3: 'Bitte geben Sie Ihren Mindesttransaktionsbetrag ein',
      tip4: 'Bitte geben Sie Ihren maximalen Transaktionsbetrag ein',
      tip5: 'Sie können Ihre speziellen Anforderungen in den Anmerkungen eintragen, zum Beispiel: die Anforderungen des Käufers, die Online-Zeit usw. ',
      paymode: 'Bezahlverfahren',
      minlimit: 'Mindesttransaktionsbetrag',
      maxlimit: 'Maximaler Transaktionsbetrag',
      remark: 'Bemerkungen Informationen',
      openautoreply: 'Automatische Antwort aktivieren',
      msg5: 'Nach der Aktivierung sendet das System automatisch die von Ihnen ausgewählte Sprache für die automatische Antwort an die andere Partei, wenn ein Benutzer über diese Werbung eine Transaktion mit Ihnen initiiert. ',
      autoreply: 'automatische Antwort',
      autoreplytip:
        'Antworten Sie nach Erhalt der Bestellung automatisch auf die Informationen des Käufers, z. B.: Zahlungsmethode, Zahlungskontonummer usw. ',
      fundpwd: 'Fondspasswort',
      fundpwdtip: 'Bitte geben Sie Ihr Fondspasswort ein',
      submit: 'Einreichen',
      warning1: 'Bitte geben Sie die richtige Nummer ein',
      warning2: 'Überlaufwert ist 0-20',
      warning3: 'Bitte geben Sie Ihren maximalen Transaktionsbetrag ein! ',
      warning4: 'Bitte geben Sie eine Ganzzahl ein',
      warning5:
        'Der maximale Transaktionsbetrag muss größer sein als der minimale Transaktionsbetrag! ',
      warning6:
        'Der maximale Transaktionsbetrag darf Ihren Gesamtverkaufsbetrag nicht überschreiten',
      warning7: 'Bitte geben Sie Ihren Mindesttransaktionsbetrag ein! ',
      warning8: 'Der minimale Transaktionsbetrag muss größer oder gleich 100 sein! ',
      warning9:
        'Der minimale Transaktionsbetrag muss kleiner sein als der maximale Transaktionsbetrag',
      sellout: 'Ausverkaufen',
      buyin: 'Kaufen',
      inputtip1: 'Bitte geben Sie die Währung ein',
      inputtip2: 'Bitte geben Sie die richtige Option ein',
      inputtip3: 'Der Überlaufwert ist 0-20 und kann nicht 0 sein',
      inputtip4: 'Bitte geben Sie den korrekten Festpreis ein',
      inputtip5:
        'Bitte geben Sie die richtige Nummer ein und der maximale Transaktionsbetrag überschreitet 100 Münzen nicht',
      inputtip6: 'Bitte geben Sie die richtige Transaktionsfrist ein',
      inputtip7: 'Bitte wählen Sie eine Transaktionsmethode',
      inputtip8: 'Bitte geben Sie das Fondspasswort ein',
      zfb: 'Alipay',
      wx: 'WeChat',
      unionpay: 'BankCard',
      submit_failure: 'Übermittlung fehlgeschlagen!',
      submit_success: '',
      submittip1:
        'Führen Sie zur Sicherheit Ihres Geldes zuerst [Authentifizierung mit echtem Namen] durch! ',
      submittip2:
        'Um die Sicherheit Ihres Geldes zu gewährleisten, führen Sie bitte zuerst [Handybindung] durch! ',
      submittip3:
        'Um die Sicherheit Ihrer Fonds zu gewährleisten, richten Sie bitte zuerst [Fondspasswort] ein! ',
      submittip4: 'Bitte binden Sie mindestens eine Zahlungsmethode',
    },
    index: {
      title: 'Hochwertige Werbeempfehlung',
      exchangetimes: 'Transaktionen',
      exchangeprice: 'Handelspreis',
      exchangelimit: 'Transaktionslimit',
      paymode: 'Bezahlverfahren',
      buy: 'Kaufen',
      sell: 'Ausverkaufen',
      viewmore: 'Mehr sehen',
      bot1: 'Sicher und zuverlässig',
      bot1_tip:
        'Das Team mit mehr als 10 Jahren Erfahrung in der Kontrolle finanzieller Risiken ist ein anpassbares Sicherheitsstrategiesystem',
      bot2: 'Schnell und bequem',
      bot2_tip:
        'Der benutzerfreie Transaktionsmodus von Punkt zu Punkt unterstützt mehrere Umtauschmethoden für Geldkanäle',
      bot3: 'Währung umfassend',
      bot3_tip:
        'Wählen Sie die gängigen Währungen für den Handel mit digitalen Vermögenswerten aus, um verschiedene Aspekte des Handels mit mehreren Vermögenswerten zu erfüllen',
      ibuy: 'Ich möchte kaufen',
      isell: 'Ich möchte verkaufen',
    },
  },
  activity: {
    all: 'Alle',
    prepare: 'Kurz vor dem Start',
    ongoing: 'wird bearbeitet',
    distributing: 'Verteilen',
    completed: 'abgeschlossen',
    progress: 'Fortschritt',
    totalsupply: 'Gesamtaktivität',
    starttime: 'Anfangszeit',
    endtime: 'Endzeit',
    viewdetail: 'siehe Einzelheiten',
    attend: 'Jetzt teilnehmen',
    tokendistribute: 'Token wird verteilt',
    baseinfo: 'Grundinformation',
    status: 'Status',
    activitytype: 'Abonnementtyp',
    activitytype0: 'Unbekannt',
    activitytype1: 'Zuerst online (Eile zu kaufen)',
    activitytype2: 'Zuerst online (sogar geteilt)',
    activitytype3: 'Positionsanteil',
    activitytype4: 'Kostenloses Abonnement',
    activitytype5: 'Abonnement für Cloud-Mining-Maschinen',
    activitytype6: 'Lock Release',
    ruledetail: 'Typbeschreibung',
    publishprice: 'Einschreibegebühr',
    activitycoin: 'Aktivitätswährung',
    acceptcoin: 'Akzeptierte Währung',
    holdcoin: 'Erforderliche Währung für das Halten von Positionen',
    limittimes: 'Persönliches Kauflimit',
    limitamount: 'Persönliches Kauflimit',
    unlimited: 'Unbegrenzt',
    alreadyamount: 'Gekaufte Menge',
    alreadyholdamount: 'Gesamtposition der Aktivitätsteilnahme',
    myalreadyholdamount: 'Meine teilnehmende Position',
    leftamount: 'Der verbleibende Betrag',
    attention: 'Beachtung',
    attentiontxt1:
      '1. Nach dem Einreichen der Teilnahme an Aktivitäten der Typen [Positionsfreigabe], [Kostenloses Abonnement], [Abonnement für Cloud Mining-Maschinen], [Position sperren] werden Assets eingefroren und nach Beendigung der Aktivität eingefroren oder entsperrt',
    attentiontxt2:
      '2. Nach der Teilnahme an den Aktivitäten [Halten von Anteilen], [Kostenloses Abonnement], [Abonnement für Cloud Mining-Maschinen], [Position sperren] kann der Benutzer den Antrag auf Teilnahme nicht kündigen',
    attentiontxt3:
      '3. Wenn die Veranstaltung aufgrund der Projektpartei und anderer Faktoren höherer Gewalt abgesagt wird, wird die ursprüngliche Route an die eingefrorenen Vermögenswerte zurückgegeben.',
    attentiontxt4:
      '* Das endgültige Auslegungsrecht dieser Veranstaltung liegt auf der offiziellen Website von NTL (ntlex.com)',
    inputamount: 'Umtauschbetrag eingeben',
    inputholdamount: 'Geben Sie den Betrag der gesperrten Position ein',
    mybalance: 'Mein verfügbares Guthaben',
    holdtips:
      'Die Teilnahme an Aktivitäten vom Typ [Holding Share] muss bis zum Ende der Aktivität gesperrt sein',
    pleaseinputamount: 'Bitte geben Sie den Umtauschbetrag ein',
    pleaseinputholdamount: 'Bitte geben Sie den Betrag der gesperrten Position ein',
    commitfailed: 'Einreichung konnte nicht teilnehmen!',
    minlimitamountfailed: 'Der Umtauschbetrag darf nicht unter dem Mindestumtauschbetrag liegen!',
    maxlimitamountfailed: 'Der Umtauschbetrag darf das maximale Kauflimit nicht überschreiten!',
    limittimesfailed:
      'Die Häufigkeit, mit der Sie teilgenommen haben, überschreitet die maximale Anzahl persönlicher Kauflimits!',
    balancenotenough: 'Mangelhaftes Gleichgewicht!',
    headertitledesc:
      'Ein offenes Labor für Investoren, Projektparteien, Börsen und andere Parteien, um gemeinsam zu gewinnen',
    currentdivided: 'Derzeit kann meine Position aufgeteilt werden',
    leveloneCount: 'Brauche Freunde der ersten Ebene',
    submit: 'Einreichen',
    tipsmobile: 'Bitte geben Sie die Computerseite ein, um teilzunehmen (ntlex.com)',
    tipsmobile1:
      'Bitte öffnen Sie (ntlex.com) auf der Computerseite und betreten Sie den Innovationsexperimentbereich, um teilzunehmen',
    intvalue: 'Bitte geben Sie eine Ganzzahl ein',
    inputminingamount: 'Geben Sie die Anzahl der gekauften Bergleute ein',
    moreactivity: 'Weitere andere Aktivitäten',
    releaseType: 'Release Type',
    releaseType0: 'Freigabe gleicher Menge',
    releaseType1: 'Proportional Release',
    lock: 'Time Release',
    releaseDetail: 'Release Details',
    lockday: 'Tag',
    lockweek: 'Woche',
    lockmonth: 'Monat',
    lockyear: 'Jahr',
    releasePercent: 'Release Ratio',
    lockFee: 'Sperrschwelle',
    releaseTimes: 'Mehrere freigeben',
    times: 'Zeiten',
  },
  invite: {
    inviteLoginName: 'Als Partner anmelden',
    chengwei: 'Erhalten Sie die höchste Chance, lebenslang in den häuslichen Dienst zurückzukehren',
    pthhr: 'Werden Sie Plattformpartner',
    partnerText:
      'Laden Sie Freunde ein, sich zu registrieren und sich mit ihrem echten Namen zu authentifizieren, um Plattform-Dividenden zu genießen',
    myinvitelink: 'Mein Einladungslink',
    copy: 'Kopieren',
    copyed: 'Kopiert',
    mylevelone: 'Mein erstklassiger Freund',
    myleveltwo: 'Mein Freund der zweiten Ebene',
    mycommission: 'Provisionserträge (USDT-Äquivalent)',
    extrareward: 'Extrabonus',
    partnerlevel: 'Partnerschaftsebene',
    ruledetail: 'Regeldetails',
    ruleprofile1: 'Binyan (ntlex.com) [Promotion Partner] ist das gesamte Netzwerk',
    ruleprofile2: 'Der höchste Prozentsatz an Rabatten',
    ruleprofile3: 'Die längste Rabattperiode (maximaler lebenslanger Rabatt)',
    ruleprofile4:
      'Die Werbeaktivitäten ermöglichen es Veranstaltern, die entsprechende Anstrengungen unternommen haben, Plattformpartner im wahrsten Sinne des Wortes zu werden, und genießen den Bonus, mit der Handelsplattform NTL (ntlex.com) zusammenzuwachsen! Die spezifischen Regeln lauten wie folgt:',
    ruletext1:
      '1. Um das Konzept digitaler Assets zu fördern und die Nutzerzahl zu erhöhen, hat NTL (ntlex.com) das seit langem wirksame Programm [Promotion Partners] ins Leben gerufen.',
    ruletext2:
      'Zwei. Es gibt zwei Ebenen, in denen Freunde eingeladen werden. Wenn A B einlädt, ist B der Freund der ersten Ebene von A. Wenn B C einlädt, gehört C dem Freund der ersten Ebene von B und auch dem Freund der zweiten Ebene von A. ',
    ruletext3:
      '3. Wenn Sie einen beförderten Freund Sign Up, müssen Sie den vom Einladenden bereitgestellten Link verwenden oder den Einladungscode des Einladenden manuell eingeben, um der Freund der ersten Ebene des Einladers zu werden.',
    ruletext4:
      'Vier. Der anreiz zur einreichung Von anreizen wird wirksam, wenn der einladungen durch einen kennwert für die einladung angemeldet ist.',
    ruletext5:
      'Fünf. Für den zeitraum Von einem monat, der mit dem zeitpunkt der einschreibung der teilnehmer beginnt, gibt es zwischen dem dienstgrad und der höhe des dienstverhältnisses unterschiede.',
    ruletext6:
      'Sechs. Die Förderung des Provisionsrabattvermögens ist die Transaktionsgebühr von Freunden auf niedrigerer Ebene, und die Rabattmünzen sind die drei grundlegenden Marktwährungen, nämlich: USDT, BTC, ETH.',
    ruletext7:
      'Sieben. Das Aktionsrabattverhältnis und die Rabattdauer korrelieren positiv mit der Anzahl der Freunde der ersten Ebene in der Aktion. Je mehr Promotoren vorhanden sind, desto höher ist der Prozentsatz der Rabatte. Das spezifische Rabattverhältnis für Werbeaktionen ist wie folgt:',
    ruletext8:
      '8. Die Förderung von TOP10 oder TOP100 in der Provisionsrabatt-Rangliste erhält gelegentlich zusätzliche Belohnungen, die offiziell von NTL (ntlex.com) ausgestellt wurden.',
    ruletext9:
      '9. Wenn andere Aktivitäten im Widerspruch zu den Aktivitäten des [Promotion-Partners] stehen, wird nach der Verhandlung entschieden, ob sie vorübergehend geändert werden sollen. Ich hoffe, dass die Partner dies verstehen.',
    ruletext10:
      'Zehn, L4 (Gouverneur), L5 (Präfekt), L6 (Jie Du Shi) Partner erhalten 5%, 10% und 15% des gesamten jährlichen Provisionsrabattes.',
    ruletext11:
      '11. Das endgültige Auslegungsrecht dieser Veranstaltung liegt bei NTL (ntlex.com).',
    ruleexampletitle: 'zum Beispiel:',
    ruleexamplecontent1:
      'Wenn der Benutzer Xiaoyan 100 Freunde der ersten Ebene und die Freunde der ersten Ebene von TA 5 Freunde der zweiten Ebene einladen würde, hätte Xiaoyan 100 Freunde der ersten Ebene und 500 Freunde der zweiten Ebene. Wenn die durchschnittliche Person Wenn Sie 3.000 Yuan pro Tag handeln, beträgt das monatliche Einkommen von Xiao Yan ungefähr: (100 * 3000 * 0,001 * 30% + 500 * 3000 * 0,001 * 10%) * 30 = 7200 / Monat. ',
    ruleexamplecontent2:
      'Wenn der Benutzer Xiaoyan 1.000 Freunde der ersten Ebene einlud und die Freunde der ersten Ebene von TA 5 Freunde der zweiten Ebene einluden, hätte Xiaoyan 1.000 Freunde der ersten Ebene und 5.000 Freunde der zweiten Ebene. Wenn die durchschnittliche Person Wenn Sie 3.000 Yuan pro Tag handeln, beträgt das monatliche Einkommen von Xiao Yan ungefähr: (1000 * 3000 * 0,001 * 50% + 5000 * 3000 * 0,001 * 20%) * 30 = 135000 / Monat. ',
    lastupdate: 'Zuletzt aktualisiert am',
    laststastic: 'Statistikfrist',
    level: 'Niveau',
    lv1: 'Lizheng',
    lv2: 'County Order',
    lv3: 'Präfekt',
    lv4: 'Der Gouverneur',
    lv5: 'Präfekt',
    lv6: 'Jiandu Shi',
    levelonecount: 'Anzahl der Freunde der ersten Ebene',
    levelonecommission: 'Rabattverhältnis / Rabattzeit für Freunde der ersten Ebene',
    leveltwocommission: 'Rabattverhältnis / Rabattzeit für Freunde der zweiten Ebene',
    partnerdivide: 'Partnerdividende',
    day: 'tage',
    alllife: 'Lebenslanger Rabatt',
    totalcommissionrank: 'Total Promotional Rebate',
    rank: 'Rang',
    userid: 'Benutzeridentifikation',
    rankday: '(Tageswache)',
    rankweek: '(Zhou Bang)',
    rankmonth: '(Monatsliste)',
    rankall: '(Allgemeine Liste)',
    promotioncount: 'Anzahl der Werbeaktionen',
    commissionusdt: 'Rabatt (USDT-Äquivalent)',
    ranktip1:
      'Die Anzahl der Einladungen ist die Anzahl der Freunde der ersten Ebene. Diese Liste ist die Rangfolge der Gesamtzahl der Rabatte.',
    ranktip2:
      'Die Anzahl der Einladungen entspricht der Anzahl der Freunde der ersten Ebene, und diese Liste entspricht der Rangfolge der Einladungsnummern der ersten Ebene',
    thanks: 'Danke, dass du mit NTL (ntlex.com) aufgewachsen bist!',
    headertip:
      'Die oben genannten Provisionsdaten werden nicht in Echtzeit aktualisiert. Das System zählt und aktualisiert alle 24 Stunden.',
    ptools: 'Promotion Toolbox',
    pt_title: 'Geschenkkarte für digitale Währung',
    pt_desc:
      'Nach dem Einlösen wird es automatisch zu einem Freund auf niedrigerer Ebene, sendet Freunde, Verwandte, Kunden und Partner. Helfen Sie den Werbepartnern, besser zu werben.',
    pt_more: 'Mehr Werkzeuge, dran bleiben',
    pt_tips:
      'Wenn Sie eine gute Idee haben, senden Sie bitte eine E-Mail anwerbung@NTL.biz, nach der Adoption gibt es Belohnungen!',
    pt_card_amount: 'Kartenbetrag',
    pt_card_deadline: 'Gültigkeitsdauer',
    pt_card_noend: 'Auf unbestimmte Zeit',
    pt_card_btn: 'Promotion-Partner erhalten 30 Freikarten',
    pt_card_btn1: 'Als werbepartner kriegt sie umsonst',
    pt_card_btn2: '',
    pt_card_btn_login: '30 Freikarten nach dem Login erhalten',
    pt_card_rule: 'Regeldetails',
    pt_card_summary:
      'Die Geschenkkarte in digitaler Währung ist eines der Werbetools, mit denen Werbepartner Offline-Freunde besser einladen können. Wenn der Zielbenutzer die Geschenkkarte einlöst, werden sie automatisch zum Offline-Freund des Veranstalters.',
    pt_card_rule1:
      '1. Jeder Benutzer ist auf 30 kostenlose Geschenkkarten beschränkt. Wenn Sie mehr Geschenkkarten ausstellen müssen, müssen Sie für die Anpassung bezahlen und den Kartengesichtsbetrag, das LOGO, den Beschreibungstext usw. anpassen. Bitte senden Sie eine E-Mail an',
    pt_card_rule2:
      '2. Kostenlose Geschenkkarten sind für jeden Benutzer auf eine beschränkt. Die von NTLEX.COM offiziell ausgestellte kostenlose Geschenkkarte ist für jeden Benutzer auf eine beschränkt, selbst wenn verschiedene Benutzer unterschiedliche Einlösungscodes erhalten. Sie können nur 1 kostenlose Geschenkkarte einlösen. Maßgeschneiderte Geschenkkarten unterliegen nicht dieser Einschränkung. ',
    pt_card_rule3:
      "3. Wenn der Benutzer vor dem Einlösen der Geschenkkarte keine 'Einladung' hat (dh der Einladungscode wurde bei der Registrierung des Kontos nicht eingegeben), wird er automatisch dem Freund der ersten Ebene des Kartenherausgebers zugeordnet. Wenn A den Einladungscode bei der Registrierung des Kontos nicht eingibt, Zu diesem Zeitpunkt gehört A keinem Freund der ersten oder zweiten Ebene, aber wenn A die von B ausgestellte Geschenkkarte austauscht, wird A automatisch zu Bs Freund der ersten Ebene. ",
    pt_card_rule4:
      'Viertens. Um zu verhindern, dass Kunden geklaut werden, wird der Buchwert der Geschenkkarte nicht in Echtzeit eingelöst. Sie müssen die Echtnamenauthentifizierung nach Erhalt durchführen.',
    pt_card_rule5:
      'Fünftens müssen Sie die Überprüfung des echten Namens abschließen, wenn Sie die kostenlose Geschenkkarte erhalten, und Sie können sie erhalten, ohne die Überprüfung des echten Namens abzuschließen, wenn Sie sie einlösen. Dies soll den Veranstaltern helfen, Freunde auf niedrigerer Ebene schneller zu finden.',
    pt_card_rule6:
      'VI. Das endgültige Auslegungsrecht der kostenlosen Geschenkkarte liegt bei ntlex.com.',
    pt_card_day: 'Himmel',
    pt_card_title_tips: 'Holen Sie sich 2.000 Yuan Promotion-Unterstützungsfonds',
    pt_card_title_tips1: 'und',
    pt_card_title_tips2: 'Äh, bill. - bill',
    pt_card_receivew_success:
      'Herzlichen Glückwunsch! Erfolgreich erhalten Sie die Geschenkkarte für die Partneraktion! Bitte gehen Sie zu [Personal Center] -> [Card & Coupon Center], um dies zu überprüfen!',
    usepromotion: 'Werbematerial verwenden',
    saveimage: 'Bild speichern',
    imagetips:
      'Wenn das Bild nicht normal heruntergeladen werden kann, verwenden Sie bitte das Screenshot-Tool, um es zu speichern!',
    pt_invite_title: 'Einladung zur Registrierung für Werbebilder',
    pt_invite_desc:
      'Exklusiver QR-Code, Sie können durch QR-Code-Registrierung automatisch ein untergeordneter Freund werden, der für die Weiterleitung in verschiedenen Gruppen oder Foren geeignet ist.',
    colum_text0: 'Rang',
    colum_text1: 'Mitglied',
    colum_text2: 'Anzahl der Werbeaktionen',
    colum_text3: 'Rabatt (USDT-Äquivalent)',
    colum_text4: 'Extrabonus',
    context_title: 'Exklusiver Einlösungscode für Werbepartner',
    context_title1: 'Scannen, um mehr zu erfahren',
    context_title2: 'Mein Einladungscode',
    context_title3: 'Einladungsbild',
  },
  uc: {
    verify: 'Verifiziert',
    retrieveprivate: {
      findText: 'Abrufen des privaten Schlüssels des Kontos',
      findText2: 'Der benutzerschlüssel wurde reaktiviert',

      inputFindtext: 'Geben Sie die E-Mail ein, die an dieses Konto gebunden ist',
      continue: 'weiter',
    },
    login: {
      welcomelogintxt: 'Willkommen bei NTL!',
      welcomelogintxt2: 'Wenn Sie noch kein Konto haben',
      welcomelogintxt3: 'Sie können hier klicken',
      welcomelogintxt4: 'Registriertes Konto',
      welcomelogintxt5: 'Login-Konto',
      welcomelogintxt6: 'Wenn Sie ein Konto haben',
      welcomelogintxt7: 'Beginnt eine neue tour des handels',
      inputPrivate: 'Bitte geben Sie den privaten Schlüssel des Kontos ein...',
      forgetPrivateTxt: 'Haben Sie den privaten Schlüssel des Kontos vergessen?',
      phoneEmail: 'Anmeldung per Mobiltelefon oder E-Mail',
      anonymousLogin: 'Anonyme Anmeldung',
      noaccount: 'Kein Account? ',
      register: 'Sign Up',
      login: 'Log in',
      welcomelogin: 'Bitte einloggen',
      usertip: 'Bitte geben Sie Ihre Telefonnummer oder E-Mail-Adresse ein',
      pwdtip: 'Bitte Passwort eingeben',
      validatecodeload: 'Bestätigungscode wird geladen',
      validatemsg: 'Bitte zuerst die Überprüfung abschließen',
      forget: 'Passwort vergessen?',
      loginvalidate: 'Bitte Benutzername eingeben',
      pwdvalidate1: 'Bitte Passwort eingeben',
      pwdvalidate2: 'Passwortlänge darf nicht kleiner als 6 Stellen sein',
      success: 'Log in erfolgreich',
      goregister: 'Zum anmelden.',
      getlostpwd: 'Passwort vergessen',
    },
    forget: {
      title: 'Passwort wiederherstellen',
      hasaccount: 'Sie haben bereits ein Konto? Bitte klicken Sie auf Anmelden',
      login: 'Log in',
      sendcode: 'Bestätigungscode senden',
      newpwd: 'Bitte geben Sie ein neues Passwort ein',
      confirmpwd: 'Bitte bestätigen Sie das Passwort erneut',
      save: 'Einreichen',
      pwdvalidate1: 'Bitte geben Sie das Bestätigungskennwort ein',
      pwdvalidate2: 'Die beiden Passworteinträge sind inkonsistent!',
      resettelpwd: 'Telefonpasswort zurücksetzen',
      resetemailpwd: 'E-Mail-Passwort zurücksetzen',
      newpwdtip: 'Bitte geben Sie ein neues Passwort ein',
      pwdvalidate3: 'Passwortlänge darf nicht kleiner als 6 Stellen sein',
      telno: 'Telefonnummer',
      smscode: 'Bitte Bestätigungscode eingeben',
      teltip: 'Bitte Telefonnummer eingeben',
      smscodetip: 'Bitte geben Sie den SMS-Bestätigungscode ein',
      email: 'Briefkasten',
      password: 'kennwort',
      NoId: 'Es gibt noch keine konten',
      emailcode: 'E-Mail-Bestätigungscode',
      emailtip: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
      emailcodetip: 'Bitte geben Sie den E-Mail-Bestätigungscode ein',
      resetpwdsuccess: 'Passwort erfolgreich zurückgesetzt',
      smswarn: 'Bitte überprüfen Sie die SMS',
      bangding: 'Scancode-Bindung',
      googleAuth: 'GoogleAuth',
      pleaseGoogleAuth: 'Bitte binden GoogleAuth',
      bindGoogleAuth: 'Gebunden GoogleAuth',
      jcbind: 'Entfernen GoogleAuth',
    },
    finance: {
      center: 'Finanzzentrum',
      personalassets: 'Münzwährungskonto',
      swapassets: 'Perpetual account',
      billdetail: 'Asset Flow',
      tradetail: 'Trading Mining',
      paydividends: 'Währungsdividenden halten',
      invitingmining: 'Bergbau Belohnung einladen',
      charge: 'Münze aufladen',
      pickup: 'Münzen abheben',
      money: {
        cointype: 'Währungsname',
        balance: 'Verfügbare Vermögenswerte',
        frozen: 'Assets einfrieren',
        operate: 'Betrieb',
        charge: 'Münze aufladen',
        pickup: 'Münzen abheben',
        onkeytrans: 'Ein Schlüssel zum Drehen',
        getaddress: 'Adresse abrufen',
        resetsuccess: 'Erfolgreich werden',
        match: 'Paarung',
        matchtip1: 'Die Anzahl der paarbaren GCX',
        matchtip2: 'Bitte geben Sie die Anzahl der Paare ein',
        matcherr1: 'Bitte geben Sie eine gültige Menge ein!',
        matcherr2: 'Die maximale Anzahl von Paaren überschritten!',
        matchsuccess: 'Pairing erfolgreich!',
        needreleased: 'Zu veröffentlichende Vermögenswerte',
        totalassets: 'Bilanzsumme gleichwertig:',
      },
      swap: {
        totalassets: 'Account Equity Conversion:',
        swap: 'Perpetual Account',
        swaptype: 'Vertragskonto',
        swapassets: 'Account Equity',
        avabalance: 'Verfügbare Spanne',
        usebalance: 'Used Margin',
        frozenbalance: 'Freeze Margin',
        profitandloss: 'Nicht realisierter Gewinn und Verlust',
        transfor: 'Geldüberweisung',
        inputtransferamount: 'Transfermenge',
        all: 'Alle übertragen',
        currencyaccount: 'Kreditkonto',
        swapaccount: 'Perpetual Contract Account',
        clickchange: 'Klicken, um die Wischrichtung zu ändern',
        avaamount: 'Übertragbarer Betrag',
        pleaseselectwallet: 'Bitte zuerst Überweisung in / aus Konto auswählen',
        pleaseinputamount: 'Bitte Überweisungsbetrag eingeben',
        oktransfer: 'Übertragung bestätigen',
      },
      second: {
        secondaccount: 'Zweites Vertragskonto',
        swap: ' Zweites Vertragskonto',
      },
      finance: {
        transfer: 'finanzielle Übertragung',
        account: 'Bankkonto',
        balance: 'Balance',
        earn: 'aufgelaufenen Zinsen',
        rate: 'Zinssatz',
        confirm: 'bestätigen Sie',
        transferAmount: 'Überweisungsbetrag',
        all: 'alles übertragen',
        coin: 'Währung',
        open: 'Positionsrekord',
        close: 'Geschlossener Stellenrekord',
        fail: 'Scheitern',
        success: 'Erfolg',
        updateTime: 'Updatezeit',
        financialManagement: 'Finanzverwaltung',
        financialOrder: 'Finanzordnung',
      },
      record: {
        start_end: 'Start- und Endzeit',
        to: 'bis',
        code: 'Codes.',
        remark: 'bemerkungen',
        operatetype: 'Operationstyp',
        search: 'suchen nach',
        charge: 'Aufladen',
        pickup: 'abheben',
        transaccount: 'Transfer',
        exchange: 'Exchange',
        otcbuy: 'Fiat Währungskauf',
        otcsell: 'Fettes Geld verkauft',
        activityaward: 'Aktivitätspreis',
        promotionaward: 'Promotion Belohnung',
        dividend: 'Dividenden',
        vote: 'Abstimmung',
        handrecharge: 'Manuelles Aufladen',
        match: 'Paarung',
        activitybuy: 'Aktivitätsaustausch',
        ctcbuy: 'CTC Buy',
        ctcsell: 'CTC Sell',
        redout: 'Rote Umschläge',
        redin: 'Collar Red Packet',
        chargetime: 'Transaktionsstunde',
        type: 'Arten von',
        fee: 'Bearbeitungsgebühr',
        shouldfee: 'Zahlbare Gebühr',
        discountfee: 'Bearbeitungsgebühr abziehen',
        realfee: 'Gebühr',

        symbol: 'Währung',
        num: 'Menge',
        status: 'Status',
        finish: 'abgeschlossen',
        activitybuy: 'Aktivitätsaustausch',
        ctcbuy: 'C2C kaufen',
        ctcsell: 'C2C verkaufen',
        quickExchange: 'Blitz',
        currentRate: 'Aktueller Wechselkurs',
        from: 'Von',
        inputexchangeamount: 'Flash-Betrag eingeben',
        inputexchangepasswd: 'Transaktionspasswort eingeben',
        chooseTransCoinUnit: 'Umrechnungswährung wählen',
        inputTransAmount: 'Geben Sie die Anzahl der Conversions ein',
        predictAmount: 'Geschätzte austauschbare Menge',
        qamount: 'Blitzmenge',
        qrate: 'Umtauschverhältnis',
        qexamount: 'Austauschmenge',
        withdrawcodein: 'Auszahlungscode und Einzahlung',
        withdrawcodeout: 'Auszahlung des Auszahlungscodes',
        contractfee: 'Perpetual Contract Handling Fee',
        contractprofit: 'Perpetual Contract Profit',
        contractloss: 'Perpetual Contract Loss',
        optionfail: 'Prognosevertrag fehlgeschlagen',
        optionfee: 'Prognosevertragsgebühr',
        optionreward: 'Prognosevertragsbonus',
        other: 'Andere',
      },
      paydividende: {
        money_holding:
          'Die kumulierten Dividenden für das Halten von Münzen wurden zurückgegeben (ETH):',
        money_hold: 'Kumulierung der zurückzugebenden Dividendenbestände (ETH):',
        paydividends: 'Währungsdividende (ETH) halten',
        account_date: 'Ankunftszeit',
        datehodld: 'Datum des Haltens der Währung',
        start_end: 'Start- und Endzeit',
        to: 'bis',
        operatetype: 'Operationstyp',
        search: 'suchen nach',
        charge: 'Aufladen',
        pickup: 'abheben',
        transaccount: 'Transfer',
        exchange: 'Exchange',
        otcbuy: 'Fiat Währungskauf',
        otcsell: 'Fettes Geld verkauft',
        activityaward: 'Aktivitätspreis',
        promotionaward: 'Promotion Belohnung',
        dividend: 'Dividenden',
        vote: 'Abstimmung',
        handrecharge: 'Manuelles Aufladen',
        match: 'Paarung',
        chargetime: 'Transaktionsstunde',
        type: 'Arten von',
        fee: 'Bearbeitungsgebühr',
        symbol: 'Währung',
        num: 'Menge',
        status: 'Status',
        finish: 'abgeschlossen',
      },
      trade: {
        accumulative_return: 'Kumulativer Bergbau (BHB):',
        accumulat_return: 'Pending Mining (BHB):',
        start_end: 'Start- und Endzeit',
        account_date: 'Ankunftszeit',
        to: 'bis',
        operatetype: 'Operationstyp',
        search: 'suchen nach',
        charge: 'Aufladen',
        pickup: 'abheben',
        transaccount: 'Transfer',
        exchange: 'Exchange',
        otcbuy: 'Fiat Währungskauf',
        otcsell: 'Fettes Geld verkauft',
        activityaward: 'Aktivitätspreis',
        promotionaward: 'Promotion Belohnung',
        dividend: 'Dividenden',
        vote: 'Abstimmung',
        handrecharge: 'Manuelles Aufladen',
        match: 'Paarung',
        chargetime: 'Zeit für die Auftragserstellung',
        type: 'Arten von',
        fee: 'Rückerstattung der Bergbaugebühr (BHB)',
        num: 'Menge',
        status: 'Status',
        finish: 'abgeschlossen',
        transactionTime: 'Transaktionsstunde',
        symbol: 'Handelspaar',
        direction: 'Handelsrichtung',
        price: 'Preis',
        entrustment: 'Vertrauenswürdiger Betrag',
        havedeal: 'Geschäft abgeschlossen',
        poundageAmount: 'Bearbeitungsgebühr',
        exchangeOrderId: 'Auftragsnummer',
        mineAmount: 'Anzahl der abzubauenden Münzen (BHB)',
        buy: 'Kaufen',
        sell: 'Verkaufen',
        limit: 'Limit Price',
        market: 'Marktpreis',
        clear: 'Klare Bedingungen',
        turnover: 'Umsatz',
      },
      inviting: {
        accumulative_return: 'Invitation Mining Belohnungen wurden zurückerstattet (BHB):',
        accumulat_return: 'Laden Sie Mining-Belohnungen zur kumulativen Rückgabe ein (BHB):',
        start_end: 'Start- und Endzeit',
        account_date: 'Ankunftszeit',
        to: 'bis',
        operatetype: 'Operationstyp',
        search: 'suchen nach',
        charge: 'Aufladen',
        pickup: 'abheben',
        transaccount: 'Transfer',
        exchange: 'Exchange',
        otcbuy: 'Fiat Währungskauf',
        otcsell: 'Fettes Geld verkauft',
        activityaward: 'Aktivitätspreis',
        promotionaward: 'Promotion Belohnung',
        dividend: 'Dividenden',
        vote: 'Abstimmung',
        handrecharge: 'Manuelles Aufladen',
        match: 'Paarung',
        chargetime: 'Zeit für die Auftragserstellung',
        type: 'Arten von',
        fee: 'Rückerstattung der Bergbaugebühr (BHB)',
        symbol: 'Währung',
        num: 'Menge',
        status: 'Status',
        finish: 'abgeschlossen',
        refereename: 'Name der empfohlenen Person',
        referetel: 'Handynummer der empfohlenen Person',
        invitingawards: 'Invitation Mining Belohnung (BHB)',
        refere: 'Schiedsrichter',
        refereinput: 'Bitte geben Sie Ihren Namen / Ihre Telefonnummer ein',
      },
      recharge: {
        recharge: 'Münze aufladen',
        symbol: 'Währung',
        address: 'Ladeadresse',
        copy: 'Kopieren',
        qrcode: 'QR-Code',
        qrcodeaddress: 'Adresse QR-Code aufladen',
        msg1: 'Laden Sie keine nicht währungsbezogenen Vermögenswerte an die oben angegebene Adresse auf, da die Vermögenswerte sonst nicht abgerufen werden. ',
        msg2: 'Nach dem Aufladen auf die oben angegebene Adresse müssen Sie den gesamten Blockchain-Netzwerkknoten bestätigen. Im Allgemeinen wird das Blockchain-Hauptnetzwerk nach 3 Netzwerkbestätigungen gutgeschrieben. ',
        msg3: 'Mindestaufladebetrag:',
        msg3_1: 'Die Aufladung, die unter dem Mindestbetrag liegt, wird nicht gutgeschrieben.',
        msg4: 'Ihre Ladeadresse ändert sich nicht häufig, Sie können sie aufladen. Wenn sich etwas ändert, werden wir unser Bestes tun, um Sie per Website-Ankündigung oder E-Mail zu benachrichtigen. ',
        msg5: 'Bitte stellen Sie sicher, dass Ihr Computer und Ihr Browser sicher sind, um zu verhindern, dass Informationen manipuliert werden oder durchgesickert sind. ',
        record: 'Datensatz aufladen',
        copysuccess: 'Erfolgreich kopieren! ',
        copyerr: 'Kopieren fehlgeschlagen! Bitte manuell kopieren ',
        time: 'Ankunftszeit',
        amount: 'Auflademenge',
        gettingaddress: 'Erhalten Sie die Ladeadresse, bitte warten Sie ...',
        getaddress: 'Adresse zum Aufladen abrufen',
        memotips:
          'Bitte geben Sie dieses Memo beim Aufladen nach Bedarf ein, da Sie sonst Ihr Vermögen verlieren.',
        withdrawrecharge: 'Auszahlungscode aufladen',
        coderechargetip: 'Bitte geben Sie den Auszahlungscode ein',
        rechargesuccess:
          'Herzlichen Glückwunsch! Der Auszahlungscode wurde erfolgreich aufgeladen!',
        rechargeconfirm: 'Bestätigung zum Aufladen',
        status: 'Status',
        protocol: 'Netzwerkprotokoll',
        status_0: 'fehlschlagen',
        status_1: 'Nicht ankommen',
        status_2: 'Empfangene Rechnung',
        protocolerr: 'Bitte wählen Sie eine Vereinbarung',
        network: 'Netzwerk',
        notaddress:
          'Sie haben keine Aufladeadresse beantragt，Bitte klicken Sie auf die Schaltfläche, um die Aufladeadresse zu erhalten',
        rechargeDisable: 'Ladefunktion ist vorübergehend nicht verfügbar',
      },
      withdraw: {
        pickup: 'Münzen abheben',
        network: 'Übertragungsnetz',
        withdrawDisable: 'Abhebungen unterbrechen',
        addressmanager: 'Verwaltung von Auszahlungsadressen',
        withdrawbycode: 'Währungscode abheben Code abheben',
        withdrawcode: 'Währungscode abheben',
        symbol: 'Währung',
        address: 'Abhebeadresse',
        num: 'Auszahlungsbetrag',
        avabalance: 'Verfügbares Guthaben',
        msg1: 'Auszahlungsbetrag ist niedriger als',
        msg2: 'Zu diesem Zeitpunkt automatisch auf dem Konto eintreffen, andernfalls ist eine manuelle Überprüfung erforderlich',
        increase: 'Anzahl erhöhen',
        tip1: 'Maximale Eingabe',
        tip11: 'Dezimalstellen, Mindestwert ist',
        tip2: 'Maximaler Wert ist',
        numtip1: 'Geben Sie den Auszahlungsbetrag ein',
        fee: 'Bearbeitungsgebühr',
        range: 'Umfang',
        arriamount: 'Ankunftsmenge',
        msg3: 'Mindestauszahlungsbetrag ist',
        msg4: 'Münze',
        msg5: 'Um die Sicherheit von Geldern zu gewährleisten, werden wir die Abhebungen manuell überprüfen, wenn sich Ihre Kontosicherheitsrichtlinie, Ihr Passwort und Ihre Abhebungen unter Verwendung einer neuen Adresse ändern. Bitte warten Sie geduldig, bis das Personal Sie per Telefon oder E-Mail kontaktiert.',
        msg6: 'Bitte stellen Sie sicher, dass Ihr Computer und Ihr Browser sicher sind, um zu verhindern, dass Informationen manipuliert werden oder durchgesickert sind. ',
        record: 'Auszahlungsdatensatz',
        symboltip: 'Bitte Währung auswählen',
        addresstip: 'Bitte geben Sie die Adresse ein',
        numtip2: 'Bitte geben Sie den korrekten Auszahlungsbetrag ein, das Minimum ist',
        numtip3: 'Die Höhe der Abhebungen darf die Bearbeitungsgebühr nicht unterschreiten',
        amounttip: 'Bitte geben Sie die Anzahl der abgezogenen Münzen ein',
        feetip1: 'Mindestabfertigungsgebühr ist',
        feetip2: 'Maximaler Wert ist',
        time: 'Abhebungszeit',
        status: 'Status',
        status_1: 'wird bearbeitet',
        status_2: 'Übertragen',
        status_3: 'Gescheitert',
        status_4: 'Erfolg',
        remark: 'Bemerkungen',
        add: 'Hinzufügen',
        addresslist: 'Adressliste',
        safevalidate: 'Sicherheitsüberprüfung',
        telno: 'Handynummer',
        smscode: 'Mobiler Bestätigungscode',
        second: 'zweite',
        clickget: 'Click to get',
        email: 'Briefkasten',
        emailcode: 'E-Mail-Bestätigungscode',
        save: 'sparen',
        delete: 'Löschen',
        telerr: 'Handynummer ist falsch',
        emailerr: 'E-Mail ist falsch',
        codeerr: 'Falscher verifikationscode',
        remarktip: 'Bitte geben Sie eine Notiz ein',
        savemsg1: 'Speichern fehlgeschlagen!',
        savemsg2: 'Erfolgreich gespeichert!',
        operate: 'Betrieb',
        fundpwdtip: 'Bitte geben Sie das Fondspasswort ein',
        click: 'Klicken',
        filtrate: 'Filterbar',
        txid: 'TxId',
        generateCode: 'Auszahlungscode generieren',
        withdrawcodelist: 'Auszahlungscodeliste',
        withdrawcodestatus: 'Status',
        submit: 'Einreichen',
        generatecodesuccess: 'Auszahlungscode erfolgreich generiert',
        code_status0: 'nicht verwendet',
        code_status3: 'Erfolg',
        network: 'Übertragungsnetz',
        protocol: 'Netzwerkprotokoll',
      },
    },
    member: {
      usercenter: 'Persönliches Zentrum',
      securitycenter: 'Sicherheitscenter',
      securitysetting: 'Sicherheitseinstellungen',
      accountsetting: 'Bezahlverfahren',
      account: 'Account Management',
      assets: 'Geld Management',
      exchange: 'Transaktionsmanagement',
      curdelegate: 'Aktueller Auftrag',
      hisdelegate: 'Geschichtskommission',
      otc: 'OTC-Management',
    },
    order: {
      ordercenter: 'Bestellzentrum',
      myorder: 'Meine Bestellung',
      myad: 'Meine Anzeigen',
    },
    regist: {
      SaveKey: 'Bewahren sie den schlüssel',
      zhanghaosiyao: 'Privater Kontoschlüssel',
      logintishi:
        'Zu diesem zeitpunkt kann der eigene benutzerschlüssel nur mit der key eingegeben werden; der schlüssel wird Von einem lokalen zufällig erzeugt und Von ihnen persönlich persönlich erzeugt. Der eintrag kann auch automatisch kopiert werden',
      nimingtishiTxt:
        'Sie können sich auch einloggen, indem sie den privatschlüssel ein - Oder ausschalten, der Von einem lokalen randomisierer erzeugt wird und in ihrem eigenen zuständigkeitsbereich angelegt wird. Andernfalls kann der schlüssel nicht gefunden werden, wenn er Von einem zentralen briefkasten in diesem account eingegeben wird',

      shuruningcheng: 'Spitzname eingeben',
      anonymousLogin: 'Anonyme Anmeldung',
      fillInvitationCode: 'Füllen Sie den Einladungscode aus',
      go_login: 'Bankdaten stehen.',
      go_login2: 'Loggen sie sich ein.',
      hasaccount: 'Sie haben bereits ein Konto? Bitte klicken Sie auf Anmelden',
      login: 'Log in',
      username: 'Nutzername',
      country: 'Land',
      smscode: 'SMS-Bestätigungscode',
      sendcode: 'Bestätigungscode senden',
      resendcode: 'Erneut senden(',
      pwd: 'Passwort',
      repwd: 'Kennwort bestätigen',
      confrimpwd: 'Kennwort bestätigen',
      agreement: 'Nehme an.',
      userprotocol: 'Nutzungsbedingungen',
      privacypolicy: 'Unsere privateigentum ist privat.',

      regist: 'Sign Up',
      teltip: 'Bitte Telefonnummer eingeben',
      telerr: 'Das Format der Handynummer ist falsch, bitte erneut eingeben',
      emailtip: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
      emailerr: 'Das E-Mail-Format ist falsch, bitte erneut eingeben',
      confirmpwdtip: 'Bitte geben Sie das Bestätigungskennwort ein',
      confirmpwderr: 'Die beiden Passworteinträge sind inkonsistent!',
      telregist: 'Sign Up Sie Ihr Telefon',
      emailregist: 'E-Mail Registrierung',
      usernametip: 'Bitte geben sie einen Benutzernamen ein',
      usernamemsg:
        'Die Länge des Benutzernamens darf nicht weniger als 3 Stellen und mehr als 15 Stellen betragen',
      countrytip: 'Bitte wähle ein Land',
      smscodetip: 'Bitte geben Sie den SMS-Bestätigungscode ein',
      pwdtip: 'Bitte geben Sie Ihr Passwort ein',
      pwdmsg: 'Passwortlänge darf nicht kleiner als 6 Stellen sein',
      telno: 'Handynummer',
      email: 'E-Mail-Addresse',
      agreementtip: 'Bitte klicken, um zuzustimmen',
      reloadChoice: 'Bitte unterzeichnen sie erneut.',
      modaltitle: 'Bitte überprüfen',
      promotion: 'Einladungscode optional',
      china: 'china',
      singapore: 'Singapur',
      korea: 'Korea',
      japan: 'Japan',
      thailand: 'Thailand',
      russia: 'Russland',
      uk: 'Großbritannien',
      vietnam: 'Vietnam',
      india: 'Indien',
      italy: 'Italien',
      hk: 'Hongkong',
      malaysia: 'Malaysia',
      taiwan: 'Taiwan',
      turkey: 'Truthahn',
      germany: 'Deutschland',
      france: 'Frankreich',
      spain: 'Spanien',
      us: 'Vereinigte Staaten',
      canada: 'Kanada',
    },
    safe: {
      oldprivateKey: 'Privater Schlüssel',
      privateKeytip: 'Bitte geben Sie den privaten Schlüssel ein',
      safelevel_low: 'Sicherheitsstufe: Niedrig',
      safelevel_high: 'Sicherheitsstufe: Hoch',
      safelevel_medium: 'Sicherheitsstufe: Mittel',
      nickname: 'Spitzname',
      bind: 'Bindung',
      binded: 'Bounded',
      binding: 'in Überprüfung',
      binderr: 'Gescheitert',
      bindretry: 'Wiederholen',
      verifypass: 'verifiziert',
      verified: 'Verifiziert',
      notverified: 'nicht zertifiziert',
      verifiedtip:
        'Um die Sicherheit Ihres Kontos zu gewährleisten, führen Sie bitte vor dem Handel die Echtnamenauthentifizierung durch! ',
      realname: 'tatsächlicher Name',
      idcard: 'Identifikationsnummer',
      upload: 'Zum Hochladen klicken',
      upload_positive: 'Foto auf der Vorderseite des Personalausweises',
      upload_negative: 'Identity Reverse Photo',
      upload_hand: 'Handausweis und persönliches Unterschriftenfoto',
      save: 'sparen',
      reset: 'Zurücksetzen',
      email: 'Briefkasten',
      bindemail: 'Mailbox binden',
      loginpwd: 'Passwort',
      emailcode: 'E-Mail-Bestätigungscode',
      clickget: 'Click to get',
      second: 'zweite',
      phone: 'Handy, Mobiltelefon',
      bindphone: 'Telefon binden',
      phonecode: 'Mobiler Bestätigungscode',
      logintip: 'Beim Anmelden bei der Plattform verwenden',
      edit: 'Ändern',
      oldpwd: 'Ursprüngliches Login-Passwort',
      newpwd: 'Neues Login-Passwort',
      confirmnewpwd: 'Bestätige das neue Passwort',
      fundpwd: 'Fondspasswort',
      fundtip:
        'Wenn das Kontoguthaben geändert wird, muss zuerst das Passwort des Fonds überprüft werden',
      set: 'Die Einstellungen',
      confirmpwd: 'Kennwort bestätigen',
      oldfundpwd: 'Ursprüngliches Fondspasswort',
      newfundpwd: 'Neues Fondspasswort',
      newpwdmsg1: 'Bitte geben Sie nicht weniger als 6 neue Login-Passwörter ein',
      newpwdmsg2: 'Das neue Login-Passwort ist inkonsistent',
      pwdmsg1: 'Bitte geben Sie ein Passwort mit mindestens 6 Ziffern ein',
      pwdmsg2: 'Passwörter sind inkonsistent',
      emailtip: 'Bitte geben Sie die Mailboxnummer ein',
      codetip: 'Bitte Bestätigungscode eingeben',
      telnotip: 'Bitte Telefonnummer eingeben',
      oldpwdtip: 'Bitte geben Sie das ursprüngliche Passwort ein',
      realnametip: 'Bitte geben Sie Ihren richtigen Namen ein',
      idcardtip: 'Bitte ID-Nummer eingeben',
      bindphonetip: 'Bitte binden Sie zuerst Ihr Telefon!',
      resetfundpwd: 'Fondspasswort zurücksetzen',
      upload_positivetip: 'Bitte laden Sie das vordere Foto Ihres Personalausweises hoch',
      upload_negativetip: 'Bitte laden Sie das umgekehrte Foto des Personalausweises hoch',
      upload_handtip: 'Bitte laden Sie ein tragbares Ausweisfoto hoch',
      save_success: 'Erfolgreich gespeichert!',
      save_failure: 'Speichern fehlgeschlagen!',
      idcard_verifymsg1:
        '1. Unterstützt JPG, PNG-Format, die Datei ist kleiner als 8 MB; die Informationen auf dem Zertifikat sind deutlich sichtbar, Änderungen oder Hindernisse sind nicht zulässig, und die Zertifikatsnummer und der Name müssen deutlich sichtbar sein.',
      idcard_verifymsg2:
        '2. Das Foto muss frei von Kappen sein, und es wird empfohlen, kein Make-up zu benötigen. Die Gesichtszüge der Person mit dem Ausweis sind deutlich sichtbar und der Arm ist vollständig freigelegt.',
      idcard_verifymsg3:
        "3. Es ist erforderlich, das Zertifikat und die handschriftliche Kopie (Name + Antragsdatum) gleichzeitig aufzubewahren. 'Alle meine Aktionen auf dieser Website sind meine eigene Operation, und ich bin mir der damit verbundenen Risiken bewusst und bin bereit, alle rechtlichen Konsequenzen dieses Kontos zu tragen.' ",
    },
    account: {
      successDelete: 'Löschen erfolgreich',
      pagetitle: 'Bindung eines echten Namenskontos',
      pagetip:
        'Bitte richten Sie Ihre Zahlungsmethode ein und verwenden Sie unbedingt Ihr Konto mit echtem Namen',
      backcardno: 'Bankkartenkontonummer',
      backcardtip: 'Persönliche Bankkarteninformationen sind nicht gebunden',
      modify: 'Ändern',
      bind: 'Bindung',
      name: 'Nachname Name',
      bankaccount: 'Eröffnung eines Bankkontos',
      bankbranch: 'Konto eröffnen',
      bankno: 'Bankkartennummer',
      confirmbankno: 'Kartennummer bestätigen',
      fundpwd: 'Fondspasswort',
      save: 'sparen',
      zfbaccount: 'Alipay-Konto',
      zfbaccounttip: 'Persönliches Alipay-Konto ist nicht gebunden',
      wxaccount: 'WeChat-Konto',
      wxaccounttip: 'Persönliches WeChat-Konto ist nicht gebunden',
      banknomsg1: 'Bitte geben Sie die richtige Bankkartennummer ein',
      banknomsg2: 'Die zweimal eingegebene Bankkartennummer ist inkonsistent!',
      verifiedmsg: 'Bitte führen Sie zuerst eine Authentifizierung mit echtem Namen durch',
      bankaccountmsg: 'Bitte wählen Sie die Bank aus, um ein Konto zu eröffnen',
      bankbranchmsg: 'Bitte geben Sie die Kontoeröffnungsfiliale ein',
      banknomsg: 'Bitte geben Sie die richtige Bankkartennummer ein',
      fundpwdmsg1: 'Bitte geben Sie das richtige Fondspasswort ein',
      fundpwdmsg2: 'Passwort darf nicht kleiner als 6 Zeichen sein',
      zfbaccountmsg: 'Bitte geben Sie die Alipay-Kontonummer ein',
      wxaccountmsg: 'Bitte geben Sie ein WeChat-Konto ein',
      save_success: 'Erfolgreich gespeichert!',
      save_failure: 'Speichern fehlgeschlagen!',
      imgtip: 'Bitte laden Sie Ihren Zahlungscode hoch',
    },
    otcorder: {
      unpaid: 'Unbezahlt',
      paided: 'Bereits bezahlt',
      finished: 'abgeschlossen',
      canceled: 'Abgesagt',
      appealing: 'Reizvoll',
      searchtip: 'Geben Sie die Bestellnummer ein, um mit der Suche zu beginnen',
      orderno: 'Bestellnummer',
      created: 'Erstellungszeitpunkt',
      symbol: 'Handelswährung',
      type: 'Art der Transaktion',
      type_sell: 'Ausverkaufen',
      type_buy: 'Kaufen',
      tradename: 'Handelspartner',
      amount: 'Menge',
      money: 'Menge',
      fee: 'Bearbeitungsgebühr',
    },
    identity: {
      certified: 'verifiziert',
      placeholder: 'Bitte geben Sie den Grund für die Stornierung an',
      apply: 'Bewerben Sie sich, um ein Unternehmen zu werden',
      become: 'Werden Sie ein NTL-zertifizierter Händler und genießen Sie mehr Handelsprivilegien',
      zhusnhu:
        'Geschäftsleute genießen exklusive Werbestände, um die Erfolgsquote von Transaktionen zu steigern',
      tijiaoziliao: 'Informationen zur Händlerzertifizierung einreichen',
      place:
        'Bitte laden Sie die vorbereiteten Händlerzertifizierungsinformationen auf die Plattform hoch und senden Sie sie ab',
      tijiao: 'Ihre Geschäftsüberprüfung wurde eingereicht',
      tijiaosuc:
        'Herzlichen Glückwunsch! Ihre Überprüfung der Unternehmenszertifizierung ist bestanden',
      tijiaofail:
        'Entschuldigung! Ihre Überprüfung der Unternehmenszertifizierung ist fehlgeschlagen',
      zhuxiaotijiao: 'Ihr Antrag auf Unternehmensstornierung wurde eingereicht',
      shenhefail: 'Die Überprüfung Ihres Antrags auf Geschäftsstornierung ist fehlgeschlagen',
      shenhesuc: 'Die Prüfung Ihres Antrags auf Geschäftsstornierung wurde bestanden',
      shangjiazhuxiao: 'Geschäftsstornierung',
      shenheshibai: 'Audit fehlgeschlagen',
      shenagain: 'Re-review',
      sheqinggain: 'Erneut bewerben',
      reason: 'der Grund',
      shenqingtuibao: 'Kapitulation beantragen',
      getquan: 'Sie haben die folgenden Berechtigungen',
      read: 'Ich habe gelesen und stimme zu',
      lijishenqing: 'sofort bewerben',
      tips: 'Eingabeaufforderung',
      wufachexiao:
        'Sie stornieren gerade das Geschäft. Nachdem Sie die Einreichung des Antrags bestätigt haben, kann er nicht mehr storniert werden.',
      suredo: 'Sind Sie sicher, diesen Vorgang auszuführen?',
      shuzizichan: 'Digital Asset Transaction Certificate',
      gerenzichan: 'Personal Digital Asset Proof',
      second: {
        line: 'Wie bewerbe ich mich, um Händler zu werden?',
        step1: 'Schritt 1: Bereiten Sie die erforderlichen Bewerbungsunterlagen vor',
        step1c1: 'Bereiten Sie die folgenden Bewerbungsunterlagen vor:',
        step1c2:
          'Mobiltelefonnummer, WeChat-ID, QQ-Nummer, persönliches Zertifikat für digitale Assets (Bild), Transaktionszertifikat für digitale Assets (Bild)',
        step2: 'Schritt 2: Antrag einreichen',
        step2c:
          'Vervollständigen Sie die Informationen zur Überprüfung der Händlerzertifizierung, die ausgefüllt und hochgeladen werden müssen, und klicken Sie auf Zur Überprüfung senden.',
        step3: 'Schritt 3: Datenüberprüfung',
        stepc:
          'Wir werden Ihre Geschäftsantragsunterlagen innerhalb von 3-5 Werktagen prüfen. Bitte beachten Sie jederzeit den Prüfungsstatus, der auf der Einreichungsseite überprüft werden kann. Nach bestandener Prüfung können Sie eine Anzeige im Bereich des legalen Devisenhandels schalten.',
        agree: 'Einfrieren zustimmen',
        agreec: 'Als Händlerdepot',
        shenqingchngweishangjia: 'Bewerben Sie sich als Händler',
      },
      yuanyin: 'der Grund',
      tijiaoshenqing: 'Bewerbung einreichen',
      bizhong: 'Margin Currency',
      shuliang: 'Margin Amount',
      chosen: 'Währung wählen',
      seat: 'Exklusiver Stand',
      service: 'Eins zu eins Service',
      lowfee: 'Niedrigere Bearbeitungsgebühr',
      phone: 'Handy, Mobiltelefon',
      balance: 'Persönliche Vermögenslage',
      cardphoto: 'Fotos auf der Vorder- und Rückseite des Personalausweises',
      wx: 'WeChat',
      exchange: 'Haben Sie jemals außerbörsliche Transaktionen mit digitalen Assets durchgeführt?',
      handphoto: 'Benutzer mit ID-Foto',
      qq: 'QQ',
      ploy: 'Gibt es eine entsprechende Risikokontrollstrategie',
      agreement: 'Certified Merchant Agreement',
      he: 'und',
      applyfor: 'Antrag bestätigen',
      sendcode: 'Bestätigungscode senden',
      confirm: 'IN ORDNUNG',
      prepare: 'Materialien vorbereiten',
      review: 'Bewertung abschicken',
      result: 'Warten auf Ergebnisse',
      passed: 'Prüfung bestanden',
      approve: 'Bitte stimmen Sie der Authentifizierungs-Händlervereinbarung zu',
      emailtip1: 'Bitte senden Sie die folgenden Materialien per E-Mail an',
      emailtip2: 'Wir werden Ihre Bewerbung so schnell wie möglich prüfen. ',
    },
    extension: {
      title1: 'gesponserte Links',
      title2: 'Freunde fördern',
      title3: 'Meine Provision',
      linkdesc:
        'Die folgende URL ist Ihre Adresse für die Werbung nach außen. Sie können sie über Freunde, QQ, WeChat, Weibo, Blogs, Foren oder Ihre eigene Website bewerben. Jeder, der diese Adresse besucht, gehört Ihnen nach der Registrierung Benutzer und wenn diese Benutzer Strategien auf dieser Website einreichen, können Sie Provisionen verdienen. Der detaillierte Promotion-Status kann in den Besuchsaufzeichnungen angezeigt werden. ',
      linktitle: 'Ihr Werbelink',
      copy: 'Kopieren',
      copy_msg1: 'Erfolgreich kopieren! ',
      copy_msg2: 'Kopieren fehlgeschlagen! Bitte manuell kopieren ',
      username: 'Nutzername',
      currrecharge: 'Aktuelle Transaktion',
      userlevel: 'Empfohlenes Niveau',
      createdtime: 'Registrierungszeit',
      currcommission: 'Aktuelle Provision',
      managerfee: 'Verwaltungsgebühr',
      yuan: 'Yuan',
      symbol: 'Währung',
      amount: 'Menge',
      remark: 'Bemerkungen',
      amounttime: 'Ausstellungszeit',
    },
    promotion: {
      title: 'Meine Beförderung',
      subtitle1: 'Meine Werbekarte',
      subtitle2: 'Exchange Record',
      subtitle3: 'Meine Einladung',
      card_column0: 'Gutscheincode',
      card_column1: 'Kartenname',
      card_column2: 'Kartenwährungstyp',
      card_column3: 'Kartenbetrag',
      card_column4: 'Gültigkeitszeitraum',
      card_column5: 'Gesamt',
      card_column6: 'Erlöst',
      card_column7: 'Empfangszeit',
      my_column0: 'Benutzer einladen',
      my_column1: 'Registrierungszeit',
      my_column2: 'Echter Namensstatus',
      gopromotion: 'Werbematerial',
      inputcardno: 'Bitte geben Sie den Einlösungscode ein',
      exchange: 'Jetzt eintauschen',
      exchangesuccess:
        'Austausch erfolgreich! Bitte gehen Sie zur Vermögensverwaltung, um Ihr Guthaben zu überprüfen!',
      exchangewithcode: 'Code-Einlösung einlösen',
    },
    activity: {
      navTitle: 'Innovationsmanagement',
      subNavTitle1: 'Ich nahm teil an',
      subNavTitle2: 'Meine Bergbaumaschine',
      subNavTitle3: 'Meine gesperrte Position',
      column1: 'Name',
      column2: 'Arten von',
      column3: 'Abonnementmenge',
      column4: 'Teilnehmende Währung',
      column5: 'Abonnementeinheit',
      column6: 'Aktueller Status',
      column7: 'Transaktionshöhe',
      column8: 'Erstellte Zeit',
      mColumn1: 'Bergbaumaschine',
      mColumn2: 'Name',
      mColumn3: 'Währung',
      mColumn4: 'Zeitraum',
      mColumn5: 'Tage',
      mColumn6: 'Ausgegraben',
      mColumn7: 'Status',
      mColumn8: 'Grundkapazität',
      mColumn9: 'Aktuelle Kapazität',
      mColumn10: 'Gesamtleistung',
      mColumn11: 'Endtermin',
      mColumn12: 'Erstellungsdatum',
      lColumn1: 'Verriegelungsposition',
      lColumn2: 'Name',
      lColumn3: 'Währung',
      lColumn4: 'Zeitraum',
      lColumn5: 'Tage',
      lColumn6: 'Veröffentlicht',
      lColumn7: 'Status',
      lColumn8: 'Grundkapazität',
      lColumn9: 'Aktuelle Kapazität',
      lColumn10: 'Gesamtleistung',
      lColumn11: 'Endtermin',
      lColumn12: 'Erstellungsdatum',
    },
    mining: {
      title: 'Meine Bergbaumaschinenliste',
      empty: 'Keine Bergbaumaschine vorübergehend',
      day: 'Himmel',
      week: 'Woche',
      month: 'Monat',
      year: 'Jahr',
      invitetip1:
        'Die Produktionskapazität dieser Bergbaumaschine kann durch Einladung von Freunden erhöht werden. Jedes Mal, wenn jemand zum Austausch gegen die Bergbaumaschine eingeladen wird, erhöht sich die Produktionskapazität',
      invitetip2: '%, die Obergrenze der Kapazitätserhöhung',
      miningUnit: 'Ausgabewährung',
      miningPeriod: 'Produktionszyklus',
      miningDays: 'Bergbauzeit',
      miningedDays: 'Minenzeit',
      miningDaysProfit: 'Grundkapazität',
      miningCurrentDaysProfit: 'Tatsächliche Kapazität',
      status0: 'Bereitgestellt werden',
      status1: 'Bereitgestellt',
      status2: 'Über',
    },
    locked: {
      title: 'Meine gesperrte Positionsliste',
      empty: 'No Lockup',
      day: 'Himmel',
      week: 'Woche',
      month: 'Monat',
      year: 'Jahr',
      invitetip1:
        'Die Kapazität dieser Sperre kann durch Einladung von Freunden erhöht werden, und jede Person, die zur Teilnahme an der Sperre eingeladen wird, erhöht die Kapazität',
      invitetip2: '%, die Obergrenze der Kapazitätserhöhung',
      miningUnit: 'Währung freigeben',
      miningPeriod: 'Release Cycle',
      miningDays: 'Total Release Period',
      miningedDays: 'Freigegebene Periode',
      miningDaysProfit: 'Basic Release',
      miningCurrentDaysProfit: 'Tatsächliche Veröffentlichung',
      status0: 'Freigegeben werden',
      status1: 'Freisetzung',
      status2: 'Über',
      totallocked: 'Total Lockup',
    },
    api: {
      apiAdmin: 'API-Verwaltung',
      createApi: 'Neuen API-Schlüssel erstellen',
      mark: 'API Notes',
      bindAddress:
        'Autorisierte IP (Die Schlüsselgültigkeitsdauer der autorisierten IP-Adresse beträgt 90 Tage)',
      hint: 'Prompt',
      part1:
        'Wir bieten Ihnen eine leistungsstarke API, über die Sie Dienste wie Marktabfragen und automatischen Handel nutzen können. Pass',
      apiDoc: 'API-Dokumentation',
      howUse: 'Sehen Sie, wie man es benutzt.',
      part2: 'Jeder Benutzer kann bis zu 5 API-Schlüssel erstellen',
      part3:
        'Bitte geben Sie Ihren API-Schlüssel nicht an, um den Verlust von Assets zu vermeiden. Aus Sicherheitsgründen wird empfohlen, eine IP an den API-Schlüssel zu binden. Jeder API-Schlüssel ist an maximal 5 IPs gebunden. Geben Sie eine einzelne Adresse direkt ein und verwenden Sie die halbe Breite für mehrere IP-Adressen Durch Kommas getrennt, z. B.: 192.168.1.1,192.168.1.2,192.168.1.3. ',
      myApiKey: 'Mein API-Schlüssel',
      ipAddress: 'IP Adresse',
      createTime: 'Erstellte Zeit',
      accessKey: 'Zugangsschlüssel',
      bindIpAddress: 'IP-Adresse binden',
      ioDays: 'Verbleibende Gültigkeitsdauer (Tage)',
      operation: 'Betrieb',
      create: 'Erstellen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      sureDelete: 'Löschen bestätigen',
      tips: 'Der Schlüssel wird nur angezeigt, wenn er hinzugefügt wird, bitte speichern Sie ihn rechtzeitig',
      copy: 'Kopieren',
      access: 'Schlüssel',
      okText: 'Bestätigen',
      cancel: 'Stornieren',
    },
  },
  cms: {
    NewExclusive: 'Und die neuen',
    Newtip:
      'Miete ein ntl-konto ein, lade freunde ein und gewähre ihnen die möglichkeit einer lebenslangen rückkehr',
    noticecenter: 'Ankündigungszentrum',
    newshelp: 'Neue Hände helfen',
    appdownload: 'APP herunterladen',
    onlineservice: 'Onlineservice',
    faq: 'häufiges Problem',
    notice: 'Ankündigung',
    servicecenter: 'Kundendienst',
    about: 'Über',
    joinus: 'begleiten Sie uns',
    aboutus: 'Über uns',
    exchangerule: 'Handelsregeln',
    useprotocol: 'Nutzungsvereinbarung',
    feenote: 'Gebührenbeschreibung',
    merchantprocotol: 'Händlervertrag',
    features: 'Plattformfunktionen',
    contactus: 'kontaktiere uns',
    noticelist: 'Ankündigungsliste',
    nextnotice: 'Nächster',
    prevnotice: 'Bisherige',
    notexist: 'Die von Ihnen besuchte Ankündigung existiert nicht oder wurde gelöscht!',
    otherhelp: 'Artikel in dieser Kategorie',
    scanforshare: 'Zum Teilen scannen',
    download: 'sofort herunterladen',
    downloadslogan: 'Biyan APP-Globale Handelsplattform für digitale Vermögenswerte',
  },
  description: {
    // message1: 'Sicherheitstechnologien auf Bankebene wie SSL und dynamische Identitätsprüfung, Sicherheit der Transaktionssicherheit; Unterstützung mehrerer Transaktionen in digitaler Währung',
    // message2: 'Strenge Markteintrittsbarrieren, um die Interessen der Plattformbenutzer zu gewährleisten; \ n 100% Anzahlung, Brieftaschen sind von heiß und kalt isoliert, um die Sicherheit der Benutzergelder zu gewährleisten',
    // message3: 'Die NTL-Plattform für den Handel mit digitalen Assets unterstützt 1.000 Transaktionen pro Sekunde und bietet Benutzern ein herzliches Handelserlebnis \ n', '
    title1: 'Finanzielle Sicherheit',
    title2: 'Schnelles Aufladen',
    title3: 'globaler Service',
    title4: 'Streng ausgewählte Vermögenswerte',
    message1:
      'Umfassendes Finanzrisikokontrollsystem und Diebstahlsicherungssystem, heißes und kaltes Portemonnaie, Mehrfachsignatursystem zur Gewährleistung der Sicherheit von Geldern',
    message2:
      'Die Ein- und Auszahlung kann innerhalb von 3 Minuten erfolgen, 24 Stunden manuelle Online-Überprüfung, um Kunden davor zu schützen, die beste Investitionsmöglichkeit zu verpassen',
    message3:
      'Globale Abdeckung des Business Service-Netzwerks, die Ihnen hilft, in globale Krypto-Assets zu investieren und mit globalen Benutzern zu handeln',
    message4:
      'Wählen Sie streng hochwertige Verschlüsselungsprojekte aus und filtern Sie 80% Projekte mit extrem hohem Risiko für Sie heraus',
    message5:
      'Binyan (ntlex.com) internationale mobile Plattform für den Handel mit digital verschlüsselten Vermögenswerten, mobiler Client, mit Schwerpunkt auf Handheld-Handelserfahrung',
    scanqrcode: 'Scannen Sie den QR-Code und laden Sie die APP herunter',
    aboutdesc1:
      'Binyan (ntlex.com) ist die weltweit führende Handelsplattform für digitale Vermögenswerte. Sie ist auf den Kaimaninseln registriert und ihr Kernteam befindet sich in Hongkong. Die Kernmitglieder von NTL (ntlex.com) kommen aus dem Top-Internet und dem Finanzwesen Die meisten Mitglieder des Unternehmens glauben fest an Bitcoin und Blockchain. Wir sind davon überzeugt, dass die Blockchain das traditionelle monopolistische Finanzsystem verändern und eine demokratischere und autonomere soziale Struktur schaffen wird. ',
    aboutdesc2:
      'Die Binyan-Plattform (ntlex.com) verfügt über eine professionelle Transaktionsstruktur auf finanzieller Ebene und eine selbst entwickelte Transaktions-Engine für die Speicheranpassung mit hoher Parallelität. Die Plattform verwendet ein vollständig kaltes Recharge-Wallet-System + Mehrfachsignatur + DDOS-Angriffssystem mit hohem Schutz und andere Transaktionsstrukturen Um die Sicherheit des Kundenvermögens zu gewährleisten. ',
    aboutdesc3:
      'Biyan (ntlex.com) Damit Kunden ihre Investitionsmöglichkeiten besser nutzen können, übernimmt die Kundendienstabteilung intern das Flat Management und richtet einen extrem schnellen Service-Reaktionsmechanismus ein. Asset-Kundendienstmanager sind das ganze Jahr über 7 * 24H online, um Kunden das Aufladen von Vermögenswerten zu ermöglichen Auszahlungen und andere Dienstleistungen stellen sicher, dass Kunden Ein- und Auszahlungen von Vermögenswerten innerhalb von 25 Minuten abschließen. ',
    aboutdesc4:
      "Biyan (ntlex.com) überprüft streng hochwertige Projekte und bietet sichere und stabile Verwahrungsdienste für Vermögenswerte. Binyan (ntlex.com) hält sich an das Konzept von 'Ehrlichkeit, Fairness, Begeisterung und Offenheit' und bemüht sich, den Benutzern zu dienen Schaffen Sie einen sicheren, zuverlässigen, effizienten und freundlichen Austausch. ",
    aboutdesc5:
      'Obwohl sich digitale Assets derzeit nur in einem kleinen Kreis befinden, glauben wir, dass diese Art von Assets, die jeder vollständig kontrollieren kann, in Zukunft beliebt sein wird. Lassen Sie uns hart arbeiten und uns darauf freuen!',
    aboutdesc6:
      'ntlex.com (Nano Token Liquidity) ist eine internationalisierte Handelsplattform für digitale Vermögenswerte und Derivate, die auf einer dezentralisierten autonomen Organisation (DAO) basiert. Ziel ist es, weltweit eine sichere, stabile, bequeme, faire und vertrauenswürdige Blockchain-Asset-Handelserfahrung für Benutzer zu bieten.',
    aboutdesc7:
      'Die NTL DAO wird von der autorisierten Cayman-Stiftung verwaltet, die im Vergleich zu herkömmlichen Kryptowährungsbörsen eine vorteilhaftere Governance-Struktur aufweist und die fairen und sicheren Handel von Vermögenswerten für Benutzer effektiv gewährleistet. Das Managementteam besteht aus Mitgliedern aus verschiedenen Ländern und Regionen weltweit, die Kernmitglieder haben Erfahrung in global bekannten Finanz- und Technologieunternehmen wie Coinbase, Binance, Morgan Stanley, Amazon und Google und verfügen über starke Fähigkeiten in globalen strategischen Betriebsführung, Finanzrisikokontrolle und Managementerfahrung.',
    aboutdesc8:
      'ntlex.com bietet eine integrierte Kryptowährungs-Asset-Serviceplattform an, einschließlich Spot-Handel, Perpetual Swap, Optionen, NFTs, Finanzierung und Kreditvergabe sowie Unterstützung für mehrere Sprachversionen wie Chinesisch, Englisch, Japanisch und Koreanisch. Das technische Konzept basiert auf Amazon AWS und Google Cloud und verfügt über Funktionen wie effektiven Schutz gegen DDOS-Angriffe, dynamische und statische Datenseparation, Hotspot-Daten-Caching, Remote Disaster Recovery, parallele Skalierbarkeit usw. Die weltweit führende technologische Architektur gewährleistet sicheren Handel für Benutzer und bietet sofortigen Zugriff auf Blockchain-Assets, Technologien zum Teilen von mehreren Währungsadressen und mehrfache Sicherheitsauthentifizierungsschutz. Gleichzeitig hat ntlex.com im Vergleich zur Branche niedrigere Gebühren für den Handel mit Kryptowährungs-Assets und Abhebungen.',
    aboutdesc9:
      'Als eine DAO-geregelte Handelsplattform, der Benutzer vertrauen können, ist ntlex.com bestrebt, die Sicherheit von Benutzer-Handelsinformationen und Vermögenswerten umfassend zu gewährleisten und den Benutzern eine herausragende Handelserfahrung zu bieten.',
    support: 'Technischer Support',
    report: 'Vorschläge',
    service: 'Kundendienst',
    apply: 'Listing beantragen',
    coop: 'Zusammenarbeit von Unternehmen',
    community: 'Biyan Community',
    wechat: 'WeChat',
    addwechat:
      "Füge 'bmate601' als WeChat-Freund hinzu und trete der WeChat-Wohlfahrtsgemeinschaft bei",
    weibo: 'Weibo',
    twitter: 'Twitter',
    biyong: 'Währung',
    telegram: 'Telegramm',
    medium: 'Mittel',
    reddit: 'Reddit',
  },
  bzb_description: {
    title1: 'Dividendenrechte',
    title2: 'Bearbeitungsgebührenrabatt',
    title3: 'Priority Subscription',
    title4: 'Wahlrecht',
    title5: 'Das erste Recht zu wissen',
    title6: 'Priority Listing',
    title7: 'Gemeinsam diskutieren und Entscheidungen treffen',
    title8: 'Mehr',
    desc1:
      'Bearbeitungsgebührendividenden, Ertragsdividenden, Währungsnotierungen, Aktiendividenden usw.',
    desc2:
      'Die Transaktionsgebühr beträgt bis zu 80% Rabatt und die Belohnung wird zurückerstattet. Die Details sind noch festzulegen',
    desc3: 'Erste Prioritätsrechte für IEO- und Boot-Promotion-Token',
    desc4:
      'Teilnahme an Abstimmungsaktivitäten der NTL-Community, einschließlich, aber nicht beschränkt auf Währungsauflistung, Rückkauf usw.',
    desc5:
      'Ein gewisser Betrag an offenen Positionen tritt in die SVIP-Gruppe ein und hat keinen Fernkontakt mit dem großen V',
    desc6: 'Nur Superknoten mit der Qualifikation, eine Auflistung zu empfehlen',
    desc7: 'Nur Superknoten haben das Recht, wichtige Entscheidungen zu diskutieren',
    desc8: 'Mehr Rechte, dran bleiben',
  },
  footer: {
    wechatkefu: 'WeChat-Kundendienst',
    notice: 'Plattformansage',
    changjian: 'häufiges Problem',
    shiyong: 'Nutzungsvereinbarung',
    feilv: 'Preisbeschreibung',
    lianxi: 'Kontakt E-mail',
    biyong: 'Münzgebrauch',
    gsmc: 'Globaler Austausch digitaler Premium-Assets',
    bah: 'P ICP Nr. 13026899-3',
    gsjj: 'Über',
    gywm: 'Über uns',
    jrwm: 'begleiten Sie uns',
    lxwm: 'kontaktiere uns',
    yqlj: 'Links',
    bzzx: 'Hilfezentrum',
    xsrm: 'Anfänger-Tutorial',
    czzn: 'Leitfaden zum Aufladen',
    ptsm: 'Plattformbeschreibung',
    fysm: 'Handelsregeln',
    fwtk: 'Nutzungsbedingungen',
    fltk: 'Gebührenbeschreibung',
    wechat: 'WeChat-Kundendienst',
    xszn: 'Ratgeber für Anfänger',
    cjwt: 'häufiges Problem',
    mztk: 'Haftungsausschluss',
    ystk: 'Datenschutz-Bestimmungen',
    tkxy: 'Nutzungsbedingungen',
    gybzb: 'Über BZB',
    kfyx: 'Kundendienst-E-Mail',
    swhz: 'Zusammenarbeit von Unternehmen',
    sbsq: 'Listing beantragen',
    jyzn: 'Handelsführer',
    bzzl: 'Währungsinformationen',
    tsjb: 'Beschwerden',
    apidoc: 'API-Schnittstelle',
    zwkf: 'Noch nicht geöffnet',
  },
  financeNav: {
    wdzc: 'Mein Vermögen',
  },
  index: {
    circulation: 'Umlaufvolumen des BHB-Sicherheits- und Entwicklungsfonds',
    hourEth: 'Das heute zu verteilende Gesamteinkommen wird umgerechnet',
    yesterdayEth: 'Die kumulierte Einkommensverteilung von gestern konvertiert',
    yesterday: 'Bergbauproduktion gestern',
    bhbTotal: 'BHB Gesamtauflage',
    bhbSecond: 'BHB Sekundärmarktauflage',
    checkMineprinciple: 'View Mining-Prinzip',
    checkFlowVolum: 'Überprüfen Sie die Liquiditätsbeschreibung',
    checkLockPosition: 'Gesperrte Position anzeigen',
    BHBregister: 'NTL-Kontoregistrierung',
    tibi: 'Abhebungs- und Ankunftszeit und -limit',
    line_plane: 'Ankündigung des BHB-Startplans, Rückgabe der Umlauf- und Bearbeitungsgebühr',
    fenpeijizhi: 'Erläuterung zum NTL-Einkommensverteilungsmechanismus',
    jiangli_jihua: 'Invitation Mining Reward Program',
    friend_fanhuan: 'Freunde einladen und zusätzliche Gebühr erstatten',
  },
  plate: {
    title: 'Plattform-Einkommensverteilungsplan (Eigenkapital der BHB-Inhaber)',
    content1:
      'Wie im Weißbuch beschrieben, wird NTL 80% des Einkommens der Plattform (nach Steuern und Gebühren) NTL-Inhabern zuweisen, und 20% des Einkommens werden zur Unterstützung der F & E und des Betriebs der Plattform verwendet.',
    content2:
      'Die Einkommensverteilung nimmt den Tag als Ausschüttungszyklus, und der 6. Juni 2018 ist der erste Ausschüttungstag. Jeden Tag danach werden alle vom Vortag zu verteilenden Erträge einmalig und proportional an die BHB-Inhaber ausgeschüttet.',
    content3:
      '(Hinweis: 1. Der BHB bezieht sich hier nur auf den freigegebenen / in Umlauf gebrachten BHB, siehe [',
    content3_1: 'Erläuterung zur BHB-Auflage / Beteiligung an der Einkommensverteilungsquote',
    content3_2:
      '2. Momentaufnahme und Berechnung einmal pro Stunde (zur vollen Stunde), und die Einkommensverteilung wird einmal am Tag ausgeführt).',
    hourFenpei: 'Das heutige Ausschüttungseinkommen entspricht',
    hourTotal: 'Heute entspricht der Gesamtumsatz der Plattform',
    xiangqing: 'Details zur heutigen Einkommensverteilung',
    yesterdaytit: 'Das tägliche Äquivalent des täglichen Ausschüttungseinkommens von gestern',
    yesterdaytotal: 'Das Gesamtäquivalent der Plattform von gestern',
    yesterdayxiangqing: 'Details zur Einkommensverteilung von gestern',
    /*yesterday: {
          total: "Gesamtplattformgebühr",
          allocated: "Zu verteilendes Einkommen",
        }*/
  },
  feereturn: {
    ruletitle: 'Rückgaberegeln',
    rulecontent:
      "Das Verteilungsverhältnis von BHB wurde im Whitepaper ausführlich erläutert. 51% des BHB werden nach und nach über die 'Transaction is Mining' -Methode an Handelsnutzer zurückgegeben. Sobald die 51% des BHB vollständig belohnt sind, wird das 'Mining' automatisch durchgeführt Beendigung.",
    recordtitle: 'Datensätze zurückgeben',
    recordcontent:
      'Täglich (UTC + 8, wie unten angegeben) werden 100% der Transaktionsgebühren, die den Benutzern am Vortag entstanden sind, in BHB umgerechnet und an die Benutzer zurückgegeben. Der umgerechnete Preis basiert auf dem Durchschnittspreis von BHB am vorherigen Handelstag (Durchschnittspreisberechnungsmethode). Ist der Gesamttransaktionsbetrag / das Gesamttransaktionsvolumen). Wir werden jeden Tag um 11.00 Uhr mit der BHB-äquivalenten Rückerstattung der Transaktionsgebühr des Vortages beginnen. ',
    /*time:"Datum",
        todaycharge: "NTL Durchschnittspreis des Tages (ETH)",
        totalChange: 'Gesamtabwicklungsgebühr für den Tag (ETH)',
        returnCharge: "Rückerstattung der Bergbaugebühr am Tag (BHB)",
        todayChargeReturn: "Bergbaueinkommen verdoppelte Planrendite (BHB) am Tag" */
  },
};
